'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Prism$1 = require('prismjs');
var mermaid = require('mermaid');
require('prismjs/themes/prism.css');
var reactDom = require('react-dom');
var katex = require('katex');
require('katex/dist/katex.css');
var flowchart = require('flowchart.js');
var marked = require('marked');
var icon = require('@noedit/icon');
var EventEmitter = require('eventemitter3');
var TurndownService = require('turndown');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Prism__default = /*#__PURE__*/_interopDefaultLegacy(Prism$1);
var mermaid__default = /*#__PURE__*/_interopDefaultLegacy(mermaid);
var katex__default = /*#__PURE__*/_interopDefaultLegacy(katex);
var flowchart__default = /*#__PURE__*/_interopDefaultLegacy(flowchart);
var EventEmitter__default = /*#__PURE__*/_interopDefaultLegacy(EventEmitter);
var TurndownService__default = /*#__PURE__*/_interopDefaultLegacy(TurndownService);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = ".App {\n  font-family: sans-serif;\n  text-align: center;\n}\nhtml,\nbody {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n  width: 100%;\n}\n#root {\n  outline: none;\n  margin: 0 20%;\n  position: relative;\n  min-height: 100vh;\n  word-break: break-all;\n  padding: 10px;\n  white-space: pre-wrap;\n  -webkit-font-smoothing: antialiased;\n  box-sizing: content-box;\n}\n.md-list-task-item {\n  list-style-type: none;\n}\n.md-list-task-item input[type='checkbox'] {\n  position: absolute;\n  top: 3px;\n  left: -25px;\n  cursor: pointer;\n}\na {\n  color: #4183c4;\n}\n.md-hr-focus {\n  outline: #4183c4 auto 5px;\n}\n.md-hr {\n  line-height: 1;\n  margin: 16px 0;\n}\n.md-hr hr {\n  height: 2px;\n  padding: 0;\n  background-color: #e7e7e7;\n  border: 0 none;\n  overflow: hidden;\n  box-sizing: content-box;\n  display: inline-block;\n  width: 100%;\n}\n.inline-meta,\n.inline-before,\n.inline-after {\n  display: none;\n  color: #aaa;\n}\n.inline img {\n  display: inline;\n}\n.inline a {\n  cursor: pointer;\n}\n.inline code {\n  display: inline;\n  color: #777777;\n  background: #f3f4f4;\n  padding: 0 2px 0 2px;\n  border: 1px solid #e7eaed;\n  border-radius: 3px;\n  font-size: 15px;\n  font-family: 'Lucida Console', Consolas, Courier, monospac;\n}\n.inline-focus .inline-meta,\n.inline-focus .inline-before,\n.inline-focus .inline-after {\n  display: inline;\n}\n.inline-focus .katex {\n  display: none;\n}\n.inline-focus .katex-error {\n  display: none;\n}\nli {\n  position: relative;\n}\nbody {\n  font-family: 'Open Sans', 'Clear Sans', 'Helvetica Neue', Helvetica, Arial, 'Segoe UI Emoji', sans-serif;\n  color: #333333;\n  color: #333;\n  line-height: 1.6;\n}\nul,\nol {\n  padding-left: 30px;\n}\nul:first-child,\nol:first-child {\n  margin-top: 0;\n}\nul:last-child,\nol:last-child {\n  margin-bottom: 0;\n}\nblockquote {\n  border-left: 4px solid #dfe2e5;\n  padding: 0 15px;\n  color: #777777;\n  margin: 0;\n}\nblockquote blockquote {\n  padding-right: 0;\n}\nthead {\n  background: #f9f9f9;\n}\ntable {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 10px 0;\n}\ntable,\nth,\ntd {\n  min-width: 20px;\n  border: 1px solid #d0d0d0;\n  padding: 2px 10px;\n}\ntr:nth-child(even) {\n  background: #f9f9f9;\n}\n.md-code {\n  position: relative;\n  width: 100%;\n  padding: 10px 0;\n}\n.md-code code {\n  width: 100%;\n  display: block;\n  padding: 8px;\n  border: 1px solid #d0d0d0;\n  background: #f3f3f3;\n  border-radius: 3px;\n  box-sizing: border-box;\n  min-height: 38px;\n}\n.md-code-focus .code-tooltip {\n  display: block;\n}\n.md-code-focus code {\n  display: block !important;\n}\n.md-code-focus .block-math {\n  border-bottom: 1px solid #ccc;\n  border-left: 1px solid #eee;\n  border-right: 1px solid #eee;\n}\n.code-tooltip {\n  display: none;\n  cursor: pointer;\n  width: 180px;\n  height: 30px;\n  position: absolute;\n  text-align: center;\n  font-size: 14px;\n  line-height: 30px;\n  background: #f3f3f3;\n  bottom: -24px;\n  right: 0;\n  z-index: 1;\n  box-shadow: 0 1px 1px 0 rgba(0, 28, 36, 0.2);\n}\n.code-tooltip input {\n  width: 100%;\n  text-align: center;\n  border: 0;\n  background: transparent;\n  width: calc(100% - 20px);\n  margin: 0 10px;\n  outline: none;\n}\n.md-math-block code {\n  display: none;\n  border-radius: 0;\n  background: #f5f6f7;\n  border: 0px;\n  padding: 26px 14px;\n  position: relative;\n}\n.md-math-block code:after {\n  content: '$$';\n  position: absolute;\n  bottom: 0px;\n  left: 2px;\n  color: #aaa;\n}\n.md-math-block code:before {\n  content: '$$';\n  position: absolute;\n  top: 0px;\n  left: 2px;\n  color: #aaa;\n}\n.md-math-block .block-math {\n  text-align: center;\n  padding: 18px 0px;\n}\n.block-flow {\n  text-align: center;\n}\n.block-flow svg {\n  max-width: 100%;\n  height: auto;\n}\n.md-table-focus .table-tools,\n.md-table-focus .table-control-left,\n.md-table-focus .table-control-top {\n  display: block !important;\n}\n.md-table {\n  position: relative;\n}\n.md-table table {\n  width: calc(100% - 20px);\n  margin: 10px;\n}\n.md-table th,\n.md-table td {\n  position: relative;\n}\n.md-table .table-control-left {\n  display: none;\n  height: 100%;\n  position: absolute;\n  width: 10px;\n  background: rgba(0, 0, 0, 0.06);\n  top: 0;\n  left: -12px;\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.2s ease-in, color 0.1s ease-out;\n}\n.md-table .table-control-left:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n.md-table .table-control-top {\n  display: none;\n  width: 100%;\n  position: absolute;\n  height: 10px;\n  background: rgba(0, 0, 0, 0.06);\n  top: -14px;\n  left: 0;\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.2s ease-in, color 0.1s ease-out;\n}\n.md-table .table-control-top:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n.md-table .table-tools {\n  display: none;\n  position: absolute;\n  top: -22px;\n  left: -2px;\n}\n.md-table .table-tools .cells-warp {\n  position: relative;\n}\n.md-table .table-tools .cells-tips-wrap {\n  position: absolute;\n  top: 100%;\n  width: 120px;\n  height: 220px;\n  background: #fff;\n  border: 1px solid;\n  margin-top: 4px;\n  z-index: 1;\n}\n.md-table .table-tools .cells-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;\n}\n.md-table .table-tools .cells-grid div {\n  width: 16px;\n  height: 16px;\n  border: 1px solid;\n  margin: 1px;\n}\n.md-table .table-tools .cells-nums {\n  display: flex;\n  justify-content: center;\n  padding-top: 8px;\n}\n.md-table .table-tools .cells-nums input {\n  width: 24px;\n  height: 18px;\n  line-height: 18px;\n  padding: 0;\n  text-align: center;\n}\n.md-table .table-tools .cells-nums button {\n  width: 32px;\n  padding: 0;\n  margin: 0;\n  height: 22px;\n  margin-left: 4px;\n}\n.toolbar {\n  display: flex;\n  background: #fff;\n  border: 1px solid;\n  padding: 2px 10px;\n  line-height: 1;\n  transform: translate3d(-50%, calc(-100% - 2px), 0px);\n}\n";
styleInject(css_248z$2);

(function (Prism) {
	var funcPattern = /\\(?:[^a-z()[\]]|[a-z*]+)/i;
	var insideEqu = {
		'equation-command': {
			pattern: funcPattern,
			alias: 'regex'
		}
	};

	Prism.languages.latex = {
		'comment': /%.*/m,
		// the verbatim environment prints whitespace to the document
		'cdata': {
			pattern: /(\\begin\{((?:verbatim|lstlisting)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
			lookbehind: true
		},
		/*
		 * equations can be between $$ $$ or $ $ or \( \) or \[ \]
		 * (all are multiline)
		 */
		'equation': [
			{
				pattern: /\$\$(?:\\[\s\S]|[^\\$])+\$\$|\$(?:\\[\s\S]|[^\\$])+\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/,
				inside: insideEqu,
				alias: 'string'
			},
			{
				pattern: /(\\begin\{((?:equation|math|eqnarray|align|multline|gather)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
				lookbehind: true,
				inside: insideEqu,
				alias: 'string'
			}
		],
		/*
		 * arguments which are keywords or references are highlighted
		 * as keywords
		 */
		'keyword': {
			pattern: /(\\(?:begin|end|ref|cite|label|usepackage|documentclass)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
			lookbehind: true
		},
		'url': {
			pattern: /(\\url\{)[^}]+(?=\})/,
			lookbehind: true
		},
		/*
		 * section or chapter headlines are highlighted as bold so that
		 * they stand out more
		 */
		'headline': {
			pattern: /(\\(?:part|chapter|section|subsection|frametitle|subsubsection|paragraph|subparagraph|subsubparagraph|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
			lookbehind: true,
			alias: 'class-name'
		},
		'function': {
			pattern: funcPattern,
			alias: 'selector'
		},
		'punctuation': /[[\]{}&]/
	};

	Prism.languages.tex = Prism.languages.latex;
	Prism.languages.context = Prism.languages.latex;
}(Prism));

Prism.languages.python = {
	'comment': {
		pattern: /(^|[^\\])#.*/,
		lookbehind: true
	},
	'string-interpolation': {
		pattern: /(?:f|rf|fr)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
		greedy: true,
		inside: {
			'interpolation': {
				// "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
				pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
				lookbehind: true,
				inside: {
					'format-spec': {
						pattern: /(:)[^:(){}]+(?=\}$)/,
						lookbehind: true
					},
					'conversion-option': {
						pattern: /![sra](?=[:}]$)/,
						alias: 'punctuation'
					},
					rest: null
				}
			},
			'string': /[\s\S]+/
		}
	},
	'triple-quoted-string': {
		pattern: /(?:[rub]|rb|br)?("""|''')[\s\S]*?\1/i,
		greedy: true,
		alias: 'string'
	},
	'string': {
		pattern: /(?:[rub]|rb|br)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
		greedy: true
	},
	'function': {
		pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
		lookbehind: true
	},
	'class-name': {
		pattern: /(\bclass\s+)\w+/i,
		lookbehind: true
	},
	'decorator': {
		pattern: /(^[\t ]*)@\w+(?:\.\w+)*/im,
		lookbehind: true,
		alias: ['annotation', 'punctuation'],
		inside: {
			'punctuation': /\./
		}
	},
	'keyword': /\b(?:and|as|assert|async|await|break|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
	'builtin': /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
	'boolean': /\b(?:True|False|None)\b/,
	'number': /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?\b/i,
	'operator': /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
	'punctuation': /[{}[\];(),.:]/
};

Prism.languages.python['string-interpolation'].inside['interpolation'].inside.rest = Prism.languages.python;

Prism.languages.py = Prism.languages.python;

(function (Prism) {

	var keywords = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/;

	// full package (optional) + parent classes (optional)
	var classNamePrefix = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source;

	// based on the java naming conventions
	var className = {
		pattern: RegExp(classNamePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
		lookbehind: true,
		inside: {
			'namespace': {
				pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
				inside: {
					'punctuation': /\./
				}
			},
			'punctuation': /\./
		}
	};

	Prism.languages.java = Prism.languages.extend('clike', {
		'class-name': [
			className,
			{
				// variables and parameters
				// this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
				pattern: RegExp(classNamePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source),
				lookbehind: true,
				inside: className.inside
			}
		],
		'keyword': keywords,
		'function': [
			Prism.languages.clike.function,
			{
				pattern: /(::\s*)[a-z_]\w*/,
				lookbehind: true
			}
		],
		'number': /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
		'operator': {
			pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
			lookbehind: true
		}
	});

	Prism.languages.insertBefore('java', 'string', {
		'triple-quoted-string': {
			// http://openjdk.java.net/jeps/355#Description
			pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
			greedy: true,
			alias: 'string'
		}
	});

	Prism.languages.insertBefore('java', 'class-name', {
		'annotation': {
			pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
			lookbehind: true,
			alias: 'punctuation'
		},
		'generics': {
			pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
			inside: {
				'class-name': className,
				'keyword': keywords,
				'punctuation': /[<>(),.:]/,
				'operator': /[?&|]/
			}
		},
		'namespace': {
			pattern: RegExp(
				/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/
					.source.replace(/<keyword>/g, function () { return keywords.source; })),
			lookbehind: true,
			inside: {
				'punctuation': /\./,
			}
		}
	});
}(Prism));

(function (Prism) {

	Prism.languages.typescript = Prism.languages.extend('javascript', {
		'class-name': {
			pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
			lookbehind: true,
			greedy: true,
			inside: null // see below
		},
		'builtin': /\b(?:string|Function|any|number|boolean|Array|symbol|console|Promise|unknown|never)\b/,
	});

	// The keywords TypeScript adds to JavaScript
	Prism.languages.typescript.keyword.push(
		/\b(?:abstract|as|declare|implements|is|keyof|readonly|require)\b/,
		// keywords that have to be followed by an identifier
		/\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
		// This is for `import type *, {}`
		/\btype\b(?=\s*(?:[\{*]|$))/
	);

	// doesn't work with TS because TS is too complex
	delete Prism.languages.typescript['parameter'];

	// a version of typescript specifically for highlighting types
	var typeInside = Prism.languages.extend('typescript', {});
	delete typeInside['class-name'];

	Prism.languages.typescript['class-name'].inside = typeInside;

	Prism.languages.insertBefore('typescript', 'function', {
		'decorator': {
			pattern: /@[$\w\xA0-\uFFFF]+/,
			inside: {
				'at': {
					pattern: /^@/,
					alias: 'operator'
				},
				'function': /^[\s\S]+/
			}
		},
		'generic-function': {
			// e.g. foo<T extends "bar" | "baz">( ...
			pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
			greedy: true,
			inside: {
				'function': /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
				'generic': {
					pattern: /<[\s\S]+/, // everything after the first <
					alias: 'class-name',
					inside: typeInside
				}
			}
		}
	});

	Prism.languages.ts = Prism.languages.typescript;

}(Prism));

(function (Prism) {
	// $ set | grep '^[A-Z][^[:space:]]*=' | cut -d= -f1 | tr '\n' '|'
	// + LC_ALL, RANDOM, REPLY, SECONDS.
	// + make sure PS1..4 are here as they are not always set,
	// - some useless things.
	var envVars = '\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b';

	var commandAfterHeredoc = {
		pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
		lookbehind: true,
		alias: 'punctuation', // this looks reasonably well in all themes
		inside: null // see below
	};

	var insideString = {
		'bash': commandAfterHeredoc,
		'environment': {
			pattern: RegExp('\\$' + envVars),
			alias: 'constant'
		},
		'variable': [
			// [0]: Arithmetic Environment
			{
				pattern: /\$?\(\([\s\S]+?\)\)/,
				greedy: true,
				inside: {
					// If there is a $ sign at the beginning highlight $(( and )) as variable
					'variable': [
						{
							pattern: /(^\$\(\([\s\S]+)\)\)/,
							lookbehind: true
						},
						/^\$\(\(/
					],
					'number': /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
					// Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
					'operator': /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
					// If there is no $ sign at the beginning highlight (( and )) as punctuation
					'punctuation': /\(\(?|\)\)?|,|;/
				}
			},
			// [1]: Command Substitution
			{
				pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
				greedy: true,
				inside: {
					'variable': /^\$\(|^`|\)$|`$/
				}
			},
			// [2]: Brace expansion
			{
				pattern: /\$\{[^}]+\}/,
				greedy: true,
				inside: {
					'operator': /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
					'punctuation': /[\[\]]/,
					'environment': {
						pattern: RegExp('(\\{)' + envVars),
						lookbehind: true,
						alias: 'constant'
					}
				}
			},
			/\$(?:\w+|[#?*!@$])/
		],
		// Escape sequences from echo and printf's manuals, and escaped quotes.
		'entity': /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|x[0-9a-fA-F]{1,2}|u[0-9a-fA-F]{4}|U[0-9a-fA-F]{8})/
	};

	Prism.languages.bash = {
		'shebang': {
			pattern: /^#!\s*\/.*/,
			alias: 'important'
		},
		'comment': {
			pattern: /(^|[^"{\\$])#.*/,
			lookbehind: true
		},
		'function-name': [
			// a) function foo {
			// b) foo() {
			// c) function foo() {
			// but not “foo {”
			{
				// a) and c)
				pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
				lookbehind: true,
				alias: 'function'
			},
			{
				// b)
				pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
				alias: 'function'
			}
		],
		// Highlight variable names as variables in for and select beginnings.
		'for-or-select': {
			pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
			alias: 'variable',
			lookbehind: true
		},
		// Highlight variable names as variables in the left-hand part
		// of assignments (“=” and “+=”).
		'assign-left': {
			pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,
			inside: {
				'environment': {
					pattern: RegExp('(^|[\\s;|&]|[<>]\\()' + envVars),
					lookbehind: true,
					alias: 'constant'
				}
			},
			alias: 'variable',
			lookbehind: true
		},
		'string': [
			// Support for Here-documents https://en.wikipedia.org/wiki/Here_document
			{
				pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
				lookbehind: true,
				greedy: true,
				inside: insideString
			},
			// Here-document with quotes around the tag
			// → No expansion (so no “inside”).
			{
				pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
				lookbehind: true,
				greedy: true,
				inside: {
					'bash': commandAfterHeredoc
				}
			},
			// “Normal” string
			{
				// https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
				pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
				lookbehind: true,
				greedy: true,
				inside: insideString
			},
			{
				// https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
				pattern: /(^|[^$\\])'[^']*'/,
				lookbehind: true,
				greedy: true
			},
			{
				// https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
				pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
				greedy: true,
				inside: {
					'entity': insideString.entity
				}
			}
		],
		'environment': {
			pattern: RegExp('\\$?' + envVars),
			alias: 'constant'
		},
		'variable': insideString.variable,
		'function': {
			pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|aptitude|apt-cache|apt-get|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
			lookbehind: true
		},
		'keyword': {
			pattern: /(^|[\s;|&]|[<>]\()(?:if|then|else|elif|fi|for|while|in|case|esac|function|select|do|done|until)(?=$|[)\s;|&])/,
			lookbehind: true
		},
		// https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
		'builtin': {
			pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|break|cd|continue|eval|exec|exit|export|getopts|hash|pwd|readonly|return|shift|test|times|trap|umask|unset|alias|bind|builtin|caller|command|declare|echo|enable|help|let|local|logout|mapfile|printf|read|readarray|source|type|typeset|ulimit|unalias|set|shopt)(?=$|[)\s;|&])/,
			lookbehind: true,
			// Alias added to make those easier to distinguish from strings.
			alias: 'class-name'
		},
		'boolean': {
			pattern: /(^|[\s;|&]|[<>]\()(?:true|false)(?=$|[)\s;|&])/,
			lookbehind: true
		},
		'file-descriptor': {
			pattern: /\B&\d\b/,
			alias: 'important'
		},
		'operator': {
			// Lots of redirections here, but not just that.
			pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
			inside: {
				'file-descriptor': {
					pattern: /^\d/,
					alias: 'important'
				}
			}
		},
		'punctuation': /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
		'number': {
			pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
			lookbehind: true
		}
	};

	commandAfterHeredoc.inside = Prism.languages.bash;

	/* Patterns in command substitution. */
	var toBeCopied = [
		'comment',
		'function-name',
		'for-or-select',
		'assign-left',
		'string',
		'environment',
		'function',
		'keyword',
		'builtin',
		'boolean',
		'file-descriptor',
		'operator',
		'punctuation',
		'number'
	];
	var inside = insideString.variable[1].inside;
	for (var i = 0; i < toBeCopied.length; i++) {
		inside[toBeCopied[i]] = Prism.languages.bash[toBeCopied[i]];
	}

	Prism.languages.shell = Prism.languages.bash;
}(Prism));

// https://www.json.org/json-en.html
Prism.languages.json = {
	'property': {
		pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
		lookbehind: true,
		greedy: true
	},
	'string': {
		pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
		lookbehind: true,
		greedy: true
	},
	'comment': {
		pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
		greedy: true
	},
	'number': /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
	'punctuation': /[{}[\],]/,
	'operator': /:/,
	'boolean': /\b(?:true|false)\b/,
	'null': {
		pattern: /\bnull\b/,
		alias: 'keyword'
	}
};

Prism.languages.webmanifest = Prism.languages.json;

(function (Prism) {
	Prism.languages.flow = Prism.languages.extend('javascript', {});

	Prism.languages.insertBefore('flow', 'keyword', {
		'type': [
			{
				pattern: /\b(?:[Nn]umber|[Ss]tring|[Bb]oolean|Function|any|mixed|null|void)\b/,
				alias: 'tag'
			}
		]
	});
	Prism.languages.flow['function-variable'].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i;
	delete Prism.languages.flow['parameter'];

	Prism.languages.insertBefore('flow', 'operator', {
		'flow-punctuation': {
			pattern: /\{\||\|\}/,
			alias: 'punctuation'
		}
	});

	if (!Array.isArray(Prism.languages.flow.keyword)) {
		Prism.languages.flow.keyword = [Prism.languages.flow.keyword];
	}
	Prism.languages.flow.keyword.unshift(
		{
			pattern: /(^|[^$]\b)(?:type|opaque|declare|Class)\b(?!\$)/,
			lookbehind: true
		},
		{
			pattern: /(^|[^$]\B)\$(?:await|Diff|Exact|Keys|ObjMap|PropertyType|Shape|Record|Supertype|Subtype|Enum)\b(?!\$)/,
			lookbehind: true
		}
	);
}(Prism));

(function (Prism) {

	// Allow only one line break
	var inner = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;

	/**
	 * This function is intended for the creation of the bold or italic pattern.
	 *
	 * This also adds a lookbehind group to the given pattern to ensure that the pattern is not backslash-escaped.
	 *
	 * _Note:_ Keep in mind that this adds a capturing group.
	 *
	 * @param {string} pattern
	 * @returns {RegExp}
	 */
	function createInline(pattern) {
		pattern = pattern.replace(/<inner>/g, function () { return inner; });
		return RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + '(?:' + pattern + ')');
	}


	var tableCell = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source;
	var tableRow = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function () { return tableCell; });
	var tableLine = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;


	Prism.languages.markdown = Prism.languages.extend('markup', {});
	Prism.languages.insertBefore('markdown', 'prolog', {
		'front-matter-block': {
			pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
			lookbehind: true,
			greedy: true,
			inside: {
				'punctuation': /^---|---$/,
				'font-matter': {
					pattern: /\S+(?:\s+\S+)*/,
					alias: ['yaml', 'language-yaml'],
					inside: Prism.languages.yaml
				}
			}
		},
		'blockquote': {
			// > ...
			pattern: /^>(?:[\t ]*>)*/m,
			alias: 'punctuation'
		},
		'table': {
			pattern: RegExp('^' + tableRow + tableLine + '(?:' + tableRow + ')*', 'm'),
			inside: {
				'table-data-rows': {
					pattern: RegExp('^(' + tableRow + tableLine + ')(?:' + tableRow + ')*$'),
					lookbehind: true,
					inside: {
						'table-data': {
							pattern: RegExp(tableCell),
							inside: Prism.languages.markdown
						},
						'punctuation': /\|/
					}
				},
				'table-line': {
					pattern: RegExp('^(' + tableRow + ')' + tableLine + '$'),
					lookbehind: true,
					inside: {
						'punctuation': /\||:?-{3,}:?/
					}
				},
				'table-header-row': {
					pattern: RegExp('^' + tableRow + '$'),
					inside: {
						'table-header': {
							pattern: RegExp(tableCell),
							alias: 'important',
							inside: Prism.languages.markdown
						},
						'punctuation': /\|/
					}
				}
			}
		},
		'code': [
			{
				// Prefixed by 4 spaces or 1 tab and preceded by an empty line
				pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
				lookbehind: true,
				alias: 'keyword'
			},
			{
				// ```optional language
				// code block
				// ```
				pattern: /^```[\s\S]*?^```$/m,
				greedy: true,
				inside: {
					'code-block': {
						pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
						lookbehind: true
					},
					'code-language': {
						pattern: /^(```).+/,
						lookbehind: true
					},
					'punctuation': /```/
				}
			}
		],
		'title': [
			{
				// title 1
				// =======

				// title 2
				// -------
				pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
				alias: 'important',
				inside: {
					punctuation: /==+$|--+$/
				}
			},
			{
				// # title 1
				// ###### title 6
				pattern: /(^\s*)#.+/m,
				lookbehind: true,
				alias: 'important',
				inside: {
					punctuation: /^#+|#+$/
				}
			}
		],
		'hr': {
			// ***
			// ---
			// * * *
			// -----------
			pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
			lookbehind: true,
			alias: 'punctuation'
		},
		'list': {
			// * item
			// + item
			// - item
			// 1. item
			pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
			lookbehind: true,
			alias: 'punctuation'
		},
		'url-reference': {
			// [id]: http://example.com "Optional title"
			// [id]: http://example.com 'Optional title'
			// [id]: http://example.com (Optional title)
			// [id]: <http://example.com> "Optional title"
			pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
			inside: {
				'variable': {
					pattern: /^(!?\[)[^\]]+/,
					lookbehind: true
				},
				'string': /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
				'punctuation': /^[\[\]!:]|[<>]/
			},
			alias: 'url'
		},
		'bold': {
			// **strong**
			// __strong__

			// allow one nested instance of italic text using the same delimiter
			pattern: createInline(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
			lookbehind: true,
			greedy: true,
			inside: {
				'content': {
					pattern: /(^..)[\s\S]+(?=..$)/,
					lookbehind: true,
					inside: {} // see below
				},
				'punctuation': /\*\*|__/
			}
		},
		'italic': {
			// *em*
			// _em_

			// allow one nested instance of bold text using the same delimiter
			pattern: createInline(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
			lookbehind: true,
			greedy: true,
			inside: {
				'content': {
					pattern: /(^.)[\s\S]+(?=.$)/,
					lookbehind: true,
					inside: {} // see below
				},
				'punctuation': /[*_]/
			}
		},
		'strike': {
			// ~~strike through~~
			// ~strike~
			// eslint-disable-next-line regexp/strict
			pattern: createInline(/(~~?)(?:(?!~)<inner>)+\2/.source),
			lookbehind: true,
			greedy: true,
			inside: {
				'content': {
					pattern: /(^~~?)[\s\S]+(?=\1$)/,
					lookbehind: true,
					inside: {} // see below
				},
				'punctuation': /~~?/
			}
		},
		'code-snippet': {
			// `code`
			// ``code``
			pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
			lookbehind: true,
			greedy: true,
			alias: ['code', 'keyword']
		},
		'url': {
			// [example](http://example.com "Optional title")
			// [example][id]
			// [example] [id]
			pattern: createInline(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
			lookbehind: true,
			greedy: true,
			inside: {
				'operator': /^!/,
				'content': {
					pattern: /(^\[)[^\]]+(?=\])/,
					lookbehind: true,
					inside: {} // see below
				},
				'variable': {
					pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
					lookbehind: true
				},
				'url': {
					pattern: /(^\]\()[^\s)]+/,
					lookbehind: true
				},
				'string': {
					pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
					lookbehind: true
				}
			}
		}
	});

	['url', 'bold', 'italic', 'strike'].forEach(function (token) {
		['url', 'bold', 'italic', 'strike', 'code-snippet'].forEach(function (inside) {
			if (token !== inside) {
				Prism.languages.markdown[token].inside.content.inside[inside] = Prism.languages.markdown[inside];
			}
		});
	});

	Prism.hooks.add('after-tokenize', function (env) {
		if (env.language !== 'markdown' && env.language !== 'md') {
			return;
		}

		function walkTokens(tokens) {
			if (!tokens || typeof tokens === 'string') {
				return;
			}

			for (var i = 0, l = tokens.length; i < l; i++) {
				var token = tokens[i];

				if (token.type !== 'code') {
					walkTokens(token.content);
					continue;
				}

				/*
				 * Add the correct `language-xxxx` class to this code block. Keep in mind that the `code-language` token
				 * is optional. But the grammar is defined so that there is only one case we have to handle:
				 *
				 * token.content = [
				 *     <span class="punctuation">```</span>,
				 *     <span class="code-language">xxxx</span>,
				 *     '\n', // exactly one new lines (\r or \n or \r\n)
				 *     <span class="code-block">...</span>,
				 *     '\n', // exactly one new lines again
				 *     <span class="punctuation">```</span>
				 * ];
				 */

				var codeLang = token.content[1];
				var codeBlock = token.content[3];

				if (codeLang && codeBlock &&
					codeLang.type === 'code-language' && codeBlock.type === 'code-block' &&
					typeof codeLang.content === 'string') {

					// this might be a language that Prism does not support

					// do some replacements to support C++, C#, and F#
					var lang = codeLang.content.replace(/\b#/g, 'sharp').replace(/\b\+\+/g, 'pp');
					// only use the first word
					lang = (/[a-z][\w-]*/i.exec(lang) || [''])[0].toLowerCase();
					var alias = 'language-' + lang;

					// add alias
					if (!codeBlock.alias) {
						codeBlock.alias = [alias];
					} else if (typeof codeBlock.alias === 'string') {
						codeBlock.alias = [codeBlock.alias, alias];
					} else {
						codeBlock.alias.push(alias);
					}
				}
			}
		}

		walkTokens(env.tokens);
	});

	Prism.hooks.add('wrap', function (env) {
		if (env.type !== 'code-block') {
			return;
		}

		var codeLang = '';
		for (var i = 0, l = env.classes.length; i < l; i++) {
			var cls = env.classes[i];
			var match = /language-(.+)/.exec(cls);
			if (match) {
				codeLang = match[1];
				break;
			}
		}

		var grammar = Prism.languages[codeLang];

		if (!grammar) {
			if (codeLang && codeLang !== 'none' && Prism.plugins.autoloader) {
				var id = 'md-' + new Date().valueOf() + '-' + Math.floor(Math.random() * 1e16);
				env.attributes['id'] = id;

				Prism.plugins.autoloader.loadLanguages(codeLang, function () {
					var ele = document.getElementById(id);
					if (ele) {
						ele.innerHTML = Prism.highlight(ele.textContent, Prism.languages[codeLang], codeLang);
					}
				});
			}
		} else {
			env.content = Prism.highlight(textContent(env.content), grammar, codeLang);
		}
	});

	var tagPattern = RegExp(Prism.languages.markup.tag.pattern.source, 'gi');

	/**
	 * A list of known entity names.
	 *
	 * This will always be incomplete to save space. The current list is the one used by lowdash's unescape function.
	 *
	 * @see {@link https://github.com/lodash/lodash/blob/2da024c3b4f9947a48517639de7560457cd4ec6c/unescape.js#L2}
	 */
	var KNOWN_ENTITY_NAMES = {
		'amp': '&',
		'lt': '<',
		'gt': '>',
		'quot': '"',
	};

	// IE 11 doesn't support `String.fromCodePoint`
	var fromCodePoint = String.fromCodePoint || String.fromCharCode;

	/**
	 * Returns the text content of a given HTML source code string.
	 *
	 * @param {string} html
	 * @returns {string}
	 */
	function textContent(html) {
		// remove all tags
		var text = html.replace(tagPattern, '');

		// decode known entities
		text = text.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function (m, code) {
			code = code.toLowerCase();

			if (code[0] === '#') {
				var value;
				if (code[1] === 'x') {
					value = parseInt(code.slice(2), 16);
				} else {
					value = Number(code.slice(1));
				}

				return fromCodePoint(value);
			} else {
				var known = KNOWN_ENTITY_NAMES[code];
				if (known) {
					return known;
				}

				// unable to decode
				return m;
			}
		});

		return text;
	}

	Prism.languages.md = Prism.languages.markdown;

}(Prism));

var css_248z$1 = ".menu-module_memu__F6bdj {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: scroll;\n  max-height: 160px;\n  background: #fff;\n  border: 1px solid #dddddd;\n  border-radius: 4px;\n  width: 140px;\n  box-shadow: 0px 0px 10px #ccc;\n  z-index: 1;\n}\n.menu-module_memu__F6bdj .menu-module_item__r-6TT {\n  width: 100%;\n  text-indent: 10px;\n  line-height: 28px;\n}\n.menu-module_memu__F6bdj .menu-module_item__r-6TT:hover {\n  background: #efefef;\n}\n.menu-module_memu__F6bdj .menu-module_item-active__fHPIm {\n  background: #efefef;\n}\n";
var styles$1 = {"memu":"menu-module_memu__F6bdj","item":"menu-module_item__r-6TT","item-active":"menu-module_item-active__fHPIm"};
styleInject(css_248z$1);

function Menu({ style = {}, onEnter = (value) => { }, opts = [] }) {
    // const [list] = useState(test);
    // const [index, setIndex] = useState(0);
    // useEffect(() => {
    //   const scrollIntoView = (i) =>
    //     document
    //       .querySelectorAll(`.${styles.item}`)
    //       ?.[i]?.scrollIntoViewIfNeeded();
    //   scrollIntoView(index);
    // }, [index]);
    // useLayoutEffect(() => {
    //   const down = () => setIndex((i) => (i >= opts.length ? 0 : i + 1));
    //   const up = () => setIndex((i) => i && i - 1);
    //   const keydown = (e) => {
    //     if (e.key === "ArrowDown") down();
    //     if (e.key === "ArrowUp") up();
    //     if (e.key === 'Enter') onEnter((document.querySelector(`.${styles["item-active"]}`) as HTMLDivElement)?.innerText )
    //   };
    //   window.addEventListener("keydown", keydown);
    //   return () => window.removeEventListener("keydown", keydown);
    // }, []);
    return (React__default["default"].createElement("div", { className: styles$1.memu, style: style }, opts.map((v, i) => (React__default["default"].createElement("div", { key: i, onClick: () => {
            console.log(v);
            onEnter(v);
        }, className: styles$1.item }, v)))));
}

var css_248z = ".tooltip-module_tooltip__JN2tC {\n  position: absolute;\n  top: 0px;\n  left: 0;\n  background: #fff;\n  border: 1px solid #d3d3d3;\n  padding: 4px 12px;\n  border-radius: 4px;\n  transform: translateX(-50%);\n  margin-top: 4px;\n}\n.tooltip-module_tooltip__JN2tC::before {\n  content: '';\n  width: 20px;\n  height: 10px;\n  background: #eee;\n  clip-path: polygon(0 100%, 50% 0, 100% 100%);\n  position: absolute;\n  border-radius: 2px;\n  left: calc(50% - 10px);\n  top: -8px;\n}\n";
var styles = {"tooltip":"tooltip-module_tooltip__JN2tC"};
styleInject(css_248z);

function Tooltip$1({ top = 0, left = 0, html }) {
    return React__default["default"].createElement("span", { className: styles.tooltip, style: { top: `${top}px`, left: `${left}px` }, dangerouslySetInnerHTML: { __html: html } });
}
function openTooltip(dom, html) {
    if (!html)
        return;
    const div = document.createElement('div');
    document.body.appendChild(div);
    const { offsetTop: y, offsetLeft: x, offsetHeight: h, offsetWidth: w } = dom;
    // const {x, y, height, width} = dom.getBoundingClientRect()
    function close(e) {
        let target = e.target;
        while (target) {
            if (target === dom)
                return;
            target = target.parentElement;
        }
        reactDom.unmountComponentAtNode(div);
        div.remove();
        window.removeEventListener('click', close);
    }
    window.addEventListener('click', close);
    reactDom.render(React__default["default"].createElement(Tooltip$1, { top: y + h, left: x + w / 2, html: html }), div);
}
// @ts-ignore
window.openTooltip = openTooltip;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function* iterationTextNode(dom) {
    var _a, _b, _c;
    if (!dom)
        return dom;
    const stack = [dom];
    while (stack.length) {
        let node = stack.pop();
        if ((_c = (_b = (_a = node) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.contains) === null || _c === void 0 ? void 0 : _c.call(_b, 'katex'))
            continue;
        if (node.nodeName === '#text') {
            yield node;
        }
        stack.push(...Array.from((node === null || node === void 0 ? void 0 : node.childNodes) || []).reverse());
    }
}
function* iterationTextBlock(block) {
    if (!block)
        return;
    const stack = [block];
    while (stack.length) {
        let block = stack.pop();
        if (['paragraph', 'heading', 'code'].includes(block.type)) {
            yield block;
        }
        stack.push(...Array.from((block === null || block === void 0 ? void 0 : block.blocks) || []).reverse());
    }
}
function getKatexHtml(text) {
    return katex__default["default"].renderToString(text, { throwOnError: false });
}
function fileToBlob(file) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Blob([new Uint8Array(yield file.arrayBuffer())], { type: file.type });
    });
}

const EditorContext = React.createContext(null);
function useEditor() {
    const editor = React.useContext(EditorContext);
    if (!editor) {
        throw new Error(`The \`useEditor\` hook must be used inside the <Editor> component's context.`);
    }
    return editor;
}

// import { path } from ".";
// import { editor } from '../editor'
Prism__default["default"].highlightAll();
// mermaid.mermaidAPI.render()
// @ts-ignore
window.mermaid = mermaid__default["default"];
// @ts-ignore
window.Prism = Prism__default["default"];
// https://mermaid-js.github.io/mermaid/#/
// http://flowchart.js.org/
function useStopBeforeinput$1(ref) {
    React.useEffect(() => {
        const stop = (e) => e.stopPropagation();
        ref.current.addEventListener('beforeinput', stop);
    }, []);
}
function useStopClick(ref) {
    React.useEffect(() => {
        const stop = (e) => e.stopPropagation();
        ref.current.addEventListener('click', stop);
    }, []);
}
const Tooltip = (props) => {
    const { lang, id, editor } = props;
    const ref = React.useRef();
    const inputRef = React.useRef();
    useStopBeforeinput$1(ref);
    useStopClick(inputRef);
    const [showMenu, setShowMenu] = React.useState(false);
    // const [lang, setLang] = useState(props.lang)
    const onFocus = () => setShowMenu(true);
    const onBlur = () => setShowMenu(false);
    const opts = Object.keys(Prism__default["default"].languages); //.filter(a => a.indexOf(lang) !== -1)
    React.useEffect(() => {
        window.addEventListener('click', onBlur);
        return () => window.removeEventListener('click', onBlur);
    }, []);
    return React__default["default"].createElement("div", { ref: ref, className: "code-tooltip", onFocus: onFocus, contentEditable: false },
        React__default["default"].createElement("input", { ref: inputRef, readOnly: true, value: lang, placeholder: '请选择语音' }),
        showMenu && opts.length > 0 && React__default["default"].createElement(Menu, { opts: opts, style: { top: '35px', left: '20px' }, onEnter: (lang) => {
                console.log({ lang });
                if (id)
                    editor.model.updateBlockById(id, { lang });
                //  setShowMenu(false)
            } }));
};
const MathCode = ({ text }) => {
    const html = Prism__default["default"].highlight(text || '\n', Prism__default["default"].languages.latex, 'latex');
    return React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("code", { dangerouslySetInnerHTML: { __html: html } }),
        React__default["default"].createElement("div", { className: "block-math", contentEditable: false, dangerouslySetInnerHTML: { __html: getKatexHtml(text) } }));
};
const FlowCode = (props) => {
    const editor = useEditor();
    const { text } = props;
    const html = Prism__default["default"].highlight(text, Prism__default["default"].languages.flow, 'flow');
    const ref = React.useRef();
    React.useEffect(() => {
        const flow = flowchart__default["default"].parse(text);
        try {
            flow.drawSVG(ref.current);
        }
        catch (error) {
            //@ts-ignore
            ref.current.innerText = error.message;
        }
        return () => flow.clean();
    }, [text]);
    return React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { style: { position: 'relative', padding: '10px 0' } },
            React__default["default"].createElement(Tooltip, Object.assign({}, props, { editor: editor })),
            React__default["default"].createElement("code", { dangerouslySetInnerHTML: { __html: html } })),
        React__default["default"].createElement("div", { className: "block-flow", ref: ref, contentEditable: false }));
};
const Code = React__default["default"].memo(React.forwardRef((props, ref) => {
    const editor = useEditor();
    React.useState(0);
    if (props.lang === 'math')
        return React__default["default"].createElement("div", { className: "md-code md-math-block", ref: ref },
            React__default["default"].createElement(MathCode, Object.assign({}, props)));
    if (props.lang === 'flow')
        return React__default["default"].createElement("div", { className: "md-code md-flow-block", ref: ref },
            React__default["default"].createElement(FlowCode, Object.assign({}, props)));
    const html = Prism__default["default"].highlight((props.text || "") + '\n', Prism__default["default"].languages[props.lang] || Prism__default["default"].languages.text, props.lang || 'text');
    return (React__default["default"].createElement("div", { className: "md-code", ref: ref },
        React__default["default"].createElement("code", { dangerouslySetInnerHTML: { __html: html } }),
        React__default["default"].createElement(Tooltip, Object.assign({}, props, { editor: editor }))));
}));

const Hr = React.forwardRef((props, ref) => {
    return (React__default["default"].createElement("div", { ref: ref, className: "md-hr" },
        React__default["default"].createElement("hr", null)));
});

function CheckBox({ value, onChange = (v) => { } }) {
    return (React__default["default"].createElement("input", { contentEditable: false, checked: value, onChange: (e) => onChange(e.target.checked), type: "checkbox" }));
}
// task 
const ListItem = React.forwardRef(({ blocks, task = false, checked, id }, ref) => {
    const editor = useEditor();
    const change = (checked) => {
        if (id)
            editor.model.updateBlockById(id, { checked });
    };
    return (React__default["default"].createElement("li", { ref: ref, className: task ? "md-list-task-item" : "" },
        task && React__default["default"].createElement(CheckBox, { value: checked, onChange: change }),
        React__default["default"].createElement(BlockList, { blocks: blocks })));
});
const List = React.forwardRef(({ blocks, ordered, start }, ref) => {
    const Cpm = ordered ? 'ol' : 'ul';
    return (React__default["default"].createElement(Cpm, { ref: ref, start: start },
        React__default["default"].createElement(BlockList, { blocks: blocks })));
});

const lex = new marked.marked.Lexer();
function htmlUnEscape(str) {
    return str.replace(/&lt;|&gt;|&quot;|&amp;/g, (match) => {
        switch (match) {
            case '&lt;':
                return '<';
            case '&gt;':
                return '>';
            case '&quot;':
                return '"';
            case '&amp;':
                return '&';
        }
    });
}
const Text = React__default["default"].memo(({ text }) => htmlUnEscape(text));
const Em = React__default["default"].memo(({ text, raw, tokens = [] }) => {
    const [before, after] = raw.split(text);
    return React__default["default"].createElement("span", { className: 'inline' },
        React__default["default"].createElement("span", { className: "inline-before" }, (before)),
        React__default["default"].createElement("em", null, tokens.length ? React__default["default"].createElement(InlineBlocks, { tokens: tokens }) : text),
        React__default["default"].createElement("span", { className: "inline-after" }, (after)));
});
const Del = React__default["default"].memo(({ text, raw, tokens = [] }) => {
    const [before, after] = raw.split(text);
    return React__default["default"].createElement("span", { className: 'inline' },
        React__default["default"].createElement("span", { className: "inline-before" }, (before)),
        React__default["default"].createElement("del", null, tokens.length ? React__default["default"].createElement(InlineBlocks, { tokens: tokens }) : text),
        React__default["default"].createElement("span", { className: "inline-after" }, (after)));
});
const Codespan = React__default["default"].memo(({ text, raw, tokens = [] }) => {
    const [before, after] = raw.split(text);
    return React__default["default"].createElement("span", { className: 'inline' },
        React__default["default"].createElement("span", { className: "inline-before" }, (before)),
        React__default["default"].createElement("code", null, tokens.length ? React__default["default"].createElement(InlineBlocks, { tokens: tokens }) : text),
        React__default["default"].createElement("span", { className: "inline-after" }, (after)));
});
const Strong = React__default["default"].memo(({ text, raw, tokens = [] }) => {
    const [before, after] = raw.split(text);
    return React__default["default"].createElement("span", { className: 'inline' },
        React__default["default"].createElement("span", { className: "inline-before" }, (before)),
        React__default["default"].createElement("strong", null, tokens.length ? React__default["default"].createElement(InlineBlocks, { tokens: tokens }) : text),
        React__default["default"].createElement("span", { className: "inline-after" }, (after)));
});
const Link = React__default["default"].memo(({ text, raw, href }) => {
    if (text === raw)
        return React__default["default"].createElement("a", { href: href }, text);
    return React__default["default"].createElement("span", { className: 'inline' },
        React__default["default"].createElement("span", { className: "inline-before" }, "["),
        React__default["default"].createElement("a", { href: href }, text),
        React__default["default"].createElement("span", { className: "inline-after" }, "]"),
        React__default["default"].createElement("span", { className: "inline-meta" }, raw.split("]")[1]));
});
const Escape = React__default["default"].memo(({ raw, text }) => {
    const [before, after] = raw.split(text);
    return React__default["default"].createElement("span", { className: 'inline' },
        React__default["default"].createElement("span", { className: "inline-before" }, (before)),
        React__default["default"].createElement("span", null, text));
});
const Image = React__default["default"].memo(({ text, raw, href }) => {
    const click = (e) => window.getSelection().collapse(e.target.previousElementSibling);
    return React__default["default"].createElement("span", { className: 'inline' },
        React__default["default"].createElement("span", { className: "inline-meta" }, raw),
        React__default["default"].createElement("img", { onClick: click, alt: text, src: href }));
});
const Html = React__default["default"].memo(({ raw }) => {
    return React__default["default"].createElement("span", { className: 'inline' }, (raw));
});
const InlineMath = React__default["default"].memo(({ text, raw, href }) => {
    const ref = React.useRef();
    // const katex = getKatexHtml(text)
    const [before, after] = raw.split(text);
    React.useEffect(() => {
        if (ref) {
            const div = document.createElement('div');
            div.innerHTML = getKatexHtml(text);
            ref.current.replaceWith(div.children[0]);
        }
    });
    return React__default["default"].createElement("span", { className: 'inline inline-math' },
        React__default["default"].createElement("span", { className: "inline-before" }, before),
        React__default["default"].createElement("span", { className: "inline-meta" }, text),
        React__default["default"].createElement("span", { ref: ref }),
        React__default["default"].createElement("span", { className: "inline-after" }, after));
});
const InlineMap = {
    'del': Del,
    'em': Em,
    'codespan': Codespan,
    'strong': Strong,
    'html': Html,
    "image": Image,
    "link": Link,
    "text": Text,
    "escape": Escape,
    "inline-math": InlineMath
};
const InlineBlocks = ({ tokens = [] }) => {
    return React__default["default"].createElement(React__default["default"].Fragment, null, tokens.map((token, i) => {
        if (!InlineMap[token.type]) {
            console.error('未找到 token', token, token.type);
        }
        const Cmp = InlineMap[token.type];
        return React__default["default"].createElement(Cmp, Object.assign({ key: i }, token));
    }));
};
const InlineText = React__default["default"].memo(({ text, id }) => {
    const tokens = lex.inlineTokens(text, []);
    if (!text || !tokens.length)
        return React__default["default"].createElement("span", { dangerouslySetInnerHTML: { __html: "<br />" } });
    return (React__default["default"].createElement("span", null,
        React__default["default"].createElement(InlineBlocks, { tokens: tokens })));
});

// TODO: 需要改成 使用 raw 数据
const Heading = React.forwardRef(({ text, depth, id, raw }, ref) => {
    const H = ("h" + depth);
    return (React__default["default"].createElement(H, { ref: ref },
        React__default["default"].createElement(InlineText, { text: text, id: id })));
});

const Blockquote = React.forwardRef(({ blocks }, ref) => {
    return (React__default["default"].createElement("blockquote", { ref: ref },
        React__default["default"].createElement(BlockList, { blocks: blocks })));
});

const Cells = () => {
    const [size, setSize] = React.useState([3, 4]);
    const [show, setShow] = React.useState(false);
    const onMove = (event) => {
        if (event.target) {
            // @ts-ignore
            const col = event.target.dataset['col'];
            // @ts-ignore
            const row = event.target.dataset['row'];
            if (col && row) {
                if (col != size[0] && row != size[1]) {
                    setSize([Number(col), Number(row)]);
                }
            }
        }
    };
    const click = (e) => {
        e.stopPropagation();
        const close = () => {
            setShow(false);
            window.removeEventListener('click', close);
        };
        window.addEventListener('click', close);
        setShow(true);
    };
    return (React__default["default"].createElement("span", { className: 'cells-warp' },
        React__default["default"].createElement(icon.Icon, { size: 10, onClick: click, type: "liebiao" }),
        show ? (React__default["default"].createElement("div", { className: 'cells-tips-wrap', onClick: (e) => e.nativeEvent.stopPropagation() },
            React__default["default"].createElement("div", { className: "cells-grid", onMouseMove: onMove }, new Array(6 * 9).fill(1).map((r, i) => {
                const col = Math.floor(i / 6) + 1;
                const row = Math.floor(i % 6) + 1;
                const props = {
                    'data-col': col,
                    'data-row': row,
                    style: {},
                };
                if (size[0] >= col && size[1] >= row) {
                    props.style = {
                        background: 'burlywood',
                    };
                }
                return React__default["default"].createElement("div", Object.assign({ key: i }, props));
            })),
            React__default["default"].createElement("div", { className: "cells-nums" },
                React__default["default"].createElement("input", { value: size[1], onChange: (e) => setSize([size[0], Number(e.target.value)]) }),
                "X",
                React__default["default"].createElement("input", { value: size[0], onChange: (e) => setSize([Number(e.target.value), size[0]]) }),
                React__default["default"].createElement("button", null, "\u786E\u8BA4")))) : ('')));
};
function useStopBeforeinput(ref) {
    React.useEffect(() => {
        const stop = (e) => e.stopPropagation();
        ref.current.addEventListener('beforeinput', stop);
    }, []);
}
const TableTools = () => {
    const ref = React.useRef();
    useStopBeforeinput(ref);
    return (React__default["default"].createElement("div", { ref: ref, contentEditable: false, className: "table-tools" },
        React__default["default"].createElement(Cells, null)));
};
function ControlLeft({ row, col, insertAfterTableRow, insertAfterTableCol, deleteTableRow }) {
    var _a;
    const editor = useEditor();
    const ref = React.useRef();
    const [pos, setPos] = React.useState({ x: 0, y: 0, width: 0 });
    const [show, setShow] = React.useState(false);
    const click = (e) => {
        e.stopPropagation();
        const close = () => {
            setShow(false);
            window.removeEventListener('click', close);
        };
        window.addEventListener('click', close);
        setShow(true);
    };
    const scollTop = document.documentElement.scrollTop || document.body.scrollTop || ((_a = editor === null || editor === void 0 ? void 0 : editor.container) === null || _a === void 0 ? void 0 : _a.scrollTop);
    React.useEffect(() => {
        const { x, y, width } = ref.current.getBoundingClientRect();
        if (pos.x != x || pos.width != width)
            setPos({ x, y, width });
    });
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { ref: ref, onClick: click, className: "table-control-left", contentEditable: false }),
        show
            ? editor.container &&
                reactDom.createPortal(React__default["default"].createElement("div", { className: "toolbar", onClick: (e) => e.nativeEvent.stopPropagation(), style: { position: 'absolute', top: scollTop + pos.y, left: pos.width >> 1 } },
                    React__default["default"].createElement(icon.Icon, { size: 20, type: 'zengjiahang', onClick: () => {
                            insertAfterTableRow(row);
                        } }),
                    React__default["default"].createElement(icon.Icon, { size: 20, type: 'shanchu', onClick: () => deleteTableRow(row) })), editor.container)
            : ''));
}
function ControlTop({ row, col, setTableAlign, insertAfterTableCol, deleteTableCol }) {
    var _a, _b;
    const editor = useEditor();
    const ref = React.useRef();
    const [pos, setPos] = React.useState({ x: 0, y: 0, height: 0, width: 0 });
    const [show, setShow] = React.useState(false);
    const click = (e) => {
        e.stopPropagation();
        const close = () => {
            setShow(false);
            window.removeEventListener('click', close);
        };
        window.addEventListener('click', close);
        setShow(true);
    };
    const scollTop = document.documentElement.scrollTop || document.body.scrollTop || ((_a = editor === null || editor === void 0 ? void 0 : editor.container) === null || _a === void 0 ? void 0 : _a.scrollTop);
    const offsetLeft = ((_b = editor === null || editor === void 0 ? void 0 : editor.container) === null || _b === void 0 ? void 0 : _b.offsetLeft) || 0;
    React.useEffect(() => {
        const { x, y, width, height } = ref.current.getBoundingClientRect();
        if (pos.x != x || pos.height != height)
            setPos({ x, y, height, width });
    });
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { ref: ref, onClick: click, className: "table-control-top", contentEditable: false }),
        show
            ? editor.container &&
                reactDom.createPortal(React__default["default"].createElement("div", { className: "toolbar", onClick: (e) => e.nativeEvent.stopPropagation(), style: { position: 'absolute', top: scollTop + pos.y, left: pos.x - offsetLeft + (pos.width >> 1) } },
                    React__default["default"].createElement(icon.Icon, { size: 20, type: 'zengjialie', onClick: () => insertAfterTableCol(col) }),
                    React__default["default"].createElement(icon.Icon, { size: 20, type: 'zuoduiqi', onClick: () => setTableAlign(col, 'left') }),
                    React__default["default"].createElement(icon.Icon, { size: 20, type: 'zuoyouduiqi', onClick: () => setTableAlign(col, 'center') }),
                    React__default["default"].createElement(icon.Icon, { size: 20, type: 'youduiqi', onClick: () => setTableAlign(col, 'right') }),
                    React__default["default"].createElement(icon.Icon, { size: 20, type: 'shanchu', onClick: () => deleteTableCol(col) })), editor.container)
            : ''));
}
function deleteTableRow(editor, tableBlock, index) {
    let header = tableBlock.header, rows;
    if (index === 1) {
        header = tableBlock.rows[0];
        rows = [...tableBlock.rows];
        rows.splice(0, 1);
    }
    else {
        rows = [...tableBlock.rows];
        rows.splice(index - 2, 1);
    }
    editor.model.updateBlock(tableBlock, { header, rows });
}
function deleteTableCol(editor, tableBlock, index) {
    let header = [...tableBlock.header];
    header.splice(index - 1, 1);
    let align = [...tableBlock.align];
    align.splice(index - 1, 1);
    let rows = [...tableBlock.rows].map(row => {
        const r = [...row];
        r.splice(index - 1, 1);
        return r;
    });
    editor.model.updateBlock(tableBlock, { header, rows, align });
}
function insertAfterTableCol(editor, tableBlock, index) {
    let header = [...tableBlock.header];
    header.splice(index, 0, editor.createParagraphBlock());
    let align = [...tableBlock.align];
    align.splice(index, 0, null);
    let rows = [...tableBlock.rows].map(row => {
        const r = [...row];
        r.splice(index, 0, editor.createParagraphBlock());
        return r;
    });
    editor.model.updateBlock(tableBlock, { header, rows, align });
}
function insertAfterTableRow(editor, tableBlock, index) {
    let rows;
    const row = new Array(tableBlock.header.length).fill(1).map(() => editor.createParagraphBlock());
    if (index === 0) {
        rows = [row, ...tableBlock.rows];
    }
    else {
        rows = [...tableBlock.rows];
        rows.splice(index - 1, 0, row);
    }
    editor.model.updateBlock(tableBlock, { header: tableBlock.header, rows });
}
function setTableAlign(editor, tableBlock, index, alignValue) {
    const align = [...tableBlock === null || tableBlock === void 0 ? void 0 : tableBlock.align];
    align[index - 1] = alignValue;
    editor.model.updateBlock(tableBlock, { align });
}
const Table = React.forwardRef((props, ref) => {
    const [focus, setFocus] = React.useState({});
    const [pos, setPos] = React.useState({});
    const editor = useEditor();
    const crlProps = {
        insertAfterTableRow: insertAfterTableRow.bind(null, editor, props),
        insertAfterTableCol: insertAfterTableCol.bind(null, editor, props),
        deleteTableRow: deleteTableRow.bind(null, editor, props),
        deleteTableCol: deleteTableCol.bind(null, editor, props),
        setTableAlign: setTableAlign.bind(null, editor, props),
    };
    return (React__default["default"].createElement("div", { ref: ref, className: "md-table" },
        React__default["default"].createElement(TableTools, null),
        React__default["default"].createElement("table", null,
            React__default["default"].createElement("thead", null,
                React__default["default"].createElement("tr", null, props.header.map((col, colIndex) => {
                    var _a;
                    return (React__default["default"].createElement("th", { key: colIndex, onKeyDown: (e) => {
                            console.log(e);
                        }, onClick: () => {
                            setFocus(col);
                            setPos({ row: 1, col: colIndex + 1 });
                        }, align: ((_a = props === null || props === void 0 ? void 0 : props.align) === null || _a === void 0 ? void 0 : _a[colIndex]) || 'left' },
                        colIndex === 0 ? React__default["default"].createElement(ControlLeft, Object.assign({}, crlProps, { row: 1, col: colIndex + 1 })) : '',
                        React__default["default"].createElement(ControlTop, Object.assign({}, crlProps, { row: 1, col: colIndex + 1 })),
                        React__default["default"].createElement(Block, Object.assign({}, col))));
                }))),
            React__default["default"].createElement("tbody", null, props.rows.map((row, rowIndex) => (React__default["default"].createElement("tr", { key: rowIndex }, row.map((col, colIndex) => {
                var _a;
                return (React__default["default"].createElement("td", { key: colIndex, onClick: () => {
                        setFocus(col);
                        setPos({ row: rowIndex + 2, col: colIndex + 1 });
                    }, align: ((_a = props === null || props === void 0 ? void 0 : props.align) === null || _a === void 0 ? void 0 : _a[colIndex]) || 'left' },
                    colIndex === 0 ? React__default["default"].createElement(ControlLeft, Object.assign({}, crlProps, { row: rowIndex + 2, col: colIndex + 1 })) : '',
                    React__default["default"].createElement(Block, Object.assign({}, col))));
            }))))))));
});

// import { editor } from "../editor";
const Paragraph = React.forwardRef(({ text, id }, ref) => {
    if (/^\`{3,10}[A-Za-z0-9]*$/.test(text)) {
        const [left] = /^\`{3,10}/.exec(text);
        const right = text.slice(left.length);
        return React__default["default"].createElement("p", { ref: ref },
            React__default["default"].createElement("span", { style: { color: "#ccc" } }, left),
            React__default["default"].createElement("span", { style: { color: "#b4654d" } }, right));
    }
    return (React__default["default"].createElement("p", { ref: ref },
        React__default["default"].createElement(InlineText, { text: text, id: id })));
});
const TextBlock = React.forwardRef(({ text, id }, ref) => {
    return (React__default["default"].createElement("p", { ref: ref },
        React__default["default"].createElement(InlineText, { text: text, id: id })));
});

function Edit({ editor, children }) {
    return React__default["default"].createElement(EditorContext.Provider, { value: editor }, children);
}
function Root() {
    const editor = useEditor();
    const [model, setModel] = React.useState(editor.model._model);
    React.useEffect(() => {
        editor.model.onChange(() => setModel(Object.assign({}, editor.model._model)));
    }, []);
    const { id, blocks } = model;
    const ref = React.useRef();
    React.useLayoutEffect(() => {
        ref.current.addEventListener("beforeinput", editor.onBeforeInput);
        ref.current.addEventListener("paste", editor.onPaste);
        ref.current.addEventListener("compositionstart", editor.onCompositionstart);
        ref.current.addEventListener("keydown", editor.onKeyDown);
        ref.current.addEventListener("compositionupdate", editor.onCompositionupdate);
        ref.current.addEventListener("compositionend", editor.onCompositionend);
        editor.idToDom.set(id, ref.current);
        editor.DomToBlock.set(ref.current, editor.idToBlock.get(id));
        editor.container = ref.current;
        return () => {
            editor.idToDom.get(id).removeEventListener("beforeinput", editor.onBeforeInput);
            editor.DomToBlock.delete(editor.idToDom.get(id));
            editor.idToDom.delete(id);
        };
    }, [id]);
    const click = (event) => {
        // console.log(event.target)
        // console.log(event)
        // @ts-ignore
        if (event.target.tagName === 'A' && event.metaKey) {
            // @ts-ignore
            window.open(event.target.href);
        }
    };
    // editor.textPath.length = 0;
    return (React__default["default"].createElement("div", { id: "root", ref: ref, contentEditable: true, suppressContentEditableWarning: true, spellCheck: false, 
        // onKeyDown={onKeyDown}
        onClick: click },
        React__default["default"].createElement(BlockList, { blocks: blocks })));
}
const BlockComponentMap = {
    hr: Hr,
    paragraph: Paragraph,
    list: List,
    list_item: ListItem,
    heading: Heading,
    blockquote: Blockquote,
    space: () => React__default["default"].createElement(React__default["default"].Fragment, null),
    text: TextBlock,
    code: Code,
    table: Table,
};
function Block(props) {
    const editor = useEditor();
    const BlockComponent = (BlockComponentMap[props.type]);
    const ref = React.useRef();
    React.useLayoutEffect(() => {
        if (ref.current) {
            editor.idToDom.set(props.id, ref.current);
            editor.DomToBlock.set(ref.current, editor.idToBlock.get(props.id));
            ref.current.dataset["type"] = props.type;
            ref.current.dataset["id"] = props.id;
        }
        return () => {
            editor.DomToBlock.delete(editor.idToDom.get(props.id));
            editor.idToDom.delete(props.id);
        };
    }, [props.id]);
    return React__default["default"].createElement(BlockComponent, Object.assign({ ref: ref }, props));
}
function BlockList({ blocks = [] }) {
    return (React__default["default"].createElement(React__default["default"].Fragment, null, blocks.map((block) => (React__default["default"].createElement(Block, Object.assign({ key: block.id }, block))))));
}

// import { BlockUtil } from "./block";
class Selection {
    constructor(editor) {
        this.selection = window.getSelection();
        this.range = null;
        this.type = "None";
        this.skipSelectionchange = false;
        this.editor = editor;
        document.addEventListener("selectionchange", this.change.bind(this));
    }
    collapse(block, offset = 0) {
        var _a, _b;
        for (let _block of iterationTextBlock(block)) {
            this.focusBlock = _block;
            this.focusOffset = offset <= (((_a = _block === null || _block === void 0 ? void 0 : _block.text) === null || _a === void 0 ? void 0 : _a.length) || 0) ? offset : (((_b = _block === null || _block === void 0 ? void 0 : _block.text) === null || _b === void 0 ? void 0 : _b.length) || 0);
            return;
        }
        console.warn('Selection collapse undefined block', block);
        // const dom = Block.getTextByid(block.id);
        // dom && this.selection.collapse(dom, dom.nodeName === "BR" ? 0 : offset);
    }
    reset() {
        let { focusBlock, focusOffset, editor } = this;
        if (this.type === "None")
            return;
        this.skipSelectionchange = true;
        const dom = editor.getDomByid(focusBlock.id);
        let offset = focusOffset;
        for (let tnode of iterationTextNode(dom)) {
            if (tnode.length >= offset) {
                return this.selection.collapse(tnode, offset);
            }
            else {
                offset -= tnode.length;
            }
        }
        const text = editor.getTextByid(focusBlock.id);
        if ((text === null || text === void 0 ? void 0 : text.nodeName) === "#text" && focusOffset > text.length)
            focusOffset = text.length;
        this.selection.collapse(text, focusOffset);
    }
    focusInline({ focusNode }) {
        var _a, _b, _c;
        Array.from(document.querySelectorAll(".inline-focus")).forEach((dom) => {
            dom.classList.remove("inline-focus");
        });
        let node = focusNode;
        while (node && !((_a = node === null || node === void 0 ? void 0 : node.dataset) === null || _a === void 0 ? void 0 : _a.type)) {
            if ((_b = node === null || node === void 0 ? void 0 : node.classList) === null || _b === void 0 ? void 0 : _b.contains('inline-math')) {
                const text = node.querySelector('.inline-meta').innerText;
                text && openTooltip(node, getKatexHtml(text));
            }
            if ((_c = node === null || node === void 0 ? void 0 : node.classList) === null || _c === void 0 ? void 0 : _c.contains("inline")) {
                node === null || node === void 0 ? void 0 : node.classList.add("inline-focus");
            }
            node = node.parentElement;
        }
    }
    focusCode({ focusNode }) {
        var _a;
        const { editor } = this;
        const block = editor.domToBlock(focusNode);
        Array.from(document.querySelectorAll(".md-code-focus")).forEach((dom) => {
            dom.classList.remove("md-code-focus");
        });
        if (block.type === "code") {
            console.log("code");
            (_a = editor.getDomByid(block.id)) === null || _a === void 0 ? void 0 : _a.classList.add("md-code-focus");
        }
    }
    focusHr({ focusNode }) {
        var _a;
        const { editor } = this;
        const block = editor.domToBlock(focusNode);
        Array.from(document.querySelectorAll(".md-hr-focus")).forEach((dom) => {
            dom.classList.remove("md-hr-focus");
        });
        if (block.type === "hr") {
            (_a = editor.getDomByid(block.id)) === null || _a === void 0 ? void 0 : _a.classList.add("md-hr-focus");
        }
    }
    focusTable({ focusNode }) {
        var _a, _b;
        const { editor } = this;
        const block = editor.domToBlock(focusNode);
        Array.from(document.querySelectorAll(".md-table-focus")).forEach((dom) => {
            dom.classList.remove("md-table-focus");
        });
        if (((_a = block === null || block === void 0 ? void 0 : block.parent) === null || _a === void 0 ? void 0 : _a.type) === "table") {
            (_b = editor.getDomByid(block.parent.id)) === null || _b === void 0 ? void 0 : _b.classList.add("md-table-focus");
        }
    }
    fixLastLine() {
        var _a;
        if ((_a = this === null || this === void 0 ? void 0 : this.focusBlock) === null || _a === void 0 ? void 0 : _a.text) {
            const { textPath } = this.editor;
            if (textPath[textPath.length - 1] === this.focusBlock.id) {
                console.log('addLastLine');
                this.editor.addLastLine();
            }
        }
    }
    scrollIntoViewIfNeeded() {
        const { selection, editor } = this;
        if (selection.focusNode) {
            editor.domToBlock(selection.focusNode);
        }
    }
    getRange() {
        if (this.type !== "Range")
            return null;
        const { startContainer, startOffset, endContainer, endOffset } = this;
        return { startContainer, startOffset, endContainer, endOffset };
    }
    change() {
        const { selection, editor } = this;
        // console.log("change", selection);
        if (selection.type === "Caret") {
            this.focusInline(selection);
            this.focusHr(selection);
            this.focusCode(selection);
            this.focusTable(selection);
            this.fixLastLine();
            // this.scrollIntoViewIfNeeded()
        }
        const anchor = editor.fixOffset(selection.anchorNode, selection.anchorOffset);
        const focus = editor.fixOffset(selection.focusNode, selection.focusOffset);
        if (this.skipSelectionchange) {
            this.skipSelectionchange = false;
            if (this.focusBlock === focus.block)
                return;
        }
        this.anchorBlock = anchor.block;
        this.anchorOffset = anchor.offset;
        this.focusBlock = focus.block;
        this.focusOffset = focus.offset;
        this.type = selection.type;
        this.range = null;
        if (selection.type === "Range") {
            const _range = selection.getRangeAt(0);
            const { startContainer, startOffset, endContainer, endOffset } = editor.range(_range);
            this.range = _range;
            this.startOffset = startOffset;
            this.endOffset = endOffset;
            this.startContainer = startContainer;
            this.endContainer = endContainer;
            this.commonAncestor = editor.domToBlock(_range.commonAncestorContainer);
        }
        // if(this.focusBlock.type === "code"){
        //   document.querySelector('#root').setAttribute('contentEditable', 'false')
        //   // contentEditable
        // }else{
        //   document.querySelector('#root').setAttribute('contentEditable', 'true')
        // }
    }
}
// export const selection = new Selection();
// @ts-ignore
// window.selection = selection;

const Event = new EventEmitter__default["default"]();

// import { BlockUtil } from "./block";
// import { editor } from "./editor";
// insert_node merge_node move_node remove_node split_node set_node
// export const operations = []
// let optimer
// export function startOperations(editor, op){
//   operations.push(op)
//   if(optimer) clearTimeout(optimer)
//   optimer = setTimeout(() => stopOperations(editor) , 10)
// }
// function stopOperations(editor){
//   const { focusBlock, focusOffset, type, range } = editor.selection
//   // editor.history.add({ ops: [...operations] , focusBlock, focusOffset, type, range: range })
//   operations.length = 0
// }
function createUpdateOperation(editor, id, arg) {
    const _arg = {};
    const keys = Object.keys(arg);
    const block = editor.getBlockByid(id);
    keys.forEach(k => _arg[k] = (block === null || block === void 0 ? void 0 : block[k]) || undefined);
    const invert = () => {
        return createOperation(editor, "update", Object.assign({ id }, _arg));
    };
    return createOperation(editor, "update", Object.assign({ id }, arg), invert);
}
function createDelOperation(editor, id) {
    const block = editor.getBlockByid(id);
    const arg = { id: block.parent.id, blocks: [...block.parent.blocks] };
    const invert = () => {
        return createOperation(editor, "update", arg);
    };
    return createOperation(editor, "delete", { id }, invert);
}
function createOperation(editor, type, arg, invert) {
    const op = {
        type,
        arg,
        invert
    };
    // if(invert) startOperations(editor, op)
    return op;
}

// import { BlockUtil } from "./block";
let index = 0;
class Model {
    constructor(editor, _model) {
        this.timer = null;
        this.editor = editor;
        this.normalize = this.normalize.bind(this);
        this._model = this.normalize(_model);
    }
    normalize(block, parent) {
        var _a;
        const { editor, normalize } = this;
        block.parent = parent;
        if (!block.id)
            block.id = ++index;
        editor.idToBlock.set(block.id, block);
        if (block.type === "root") {
            if (!(block === null || block === void 0 ? void 0 : block.blocks) || block.blocks.length === 0) {
                block.blocks = [editor.createParagraphBlock()];
            }
        }
        (_a = block === null || block === void 0 ? void 0 : block.blocks) === null || _a === void 0 ? void 0 : _a.forEach((b) => normalize(b, block));
        if (["list_item", "blockquote", "list"].includes(block.type)) {
            if (block.blocks.length === 0) {
                this.deleteBlock(block.id);
            }
        }
        if (block.type === "table") {
            block.blocks = [];
            block.align = new Array(block.header.length).fill(null).map((v, i) => block.align[i] || v);
            // block.align.fill(null)
            block.header.forEach((b) => {
                block.blocks.push(b);
                normalize(b, block);
            });
            block.rows.forEach((row = []) => row.forEach((b) => {
                block.blocks.push(b);
                normalize(b, block);
            }));
        }
        return block;
    }
    setModel(_model) {
        this.normalize = this.normalize.bind(this);
        this._model = this.normalize(_model);
        Event.emit("model-change", this.editor.model);
    }
    onChange(cb) {
        Event.on("model-change", cb, this.editor);
    }
    applyModelChange() {
        const { editor } = this;
        const { selection } = editor;
        if (this.timer)
            clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.normalize(this._model);
            Event.emit("model-change", editor.model);
            selection.reset();
        }, 0);
    }
    applyOperation(operation) {
        const { editor } = this;
        const { type, arg } = operation;
        if (type === "update") {
            const block = editor.getBlockByid(arg.id);
            const keys = Object.keys(arg);
            keys.forEach((k) => {
                block[k] = arg[k];
            });
        }
        if (type === "delete") {
            const block = editor.getBlockByid(arg.id);
            block.parent.blocks = block.parent.blocks.filter(({ id }) => id !== arg.id);
        }
        Event.emit("apply-operation", operation);
        this.applyModelChange();
    }
    deleteBlock(id) {
        this.applyOperation(createDelOperation(this.editor, id));
    }
    deleteContent(range) {
        var _a, _b, _c;
        const { editor } = this;
        const _range = range instanceof StaticRange ? editor.range(range) : range;
        const { selection } = this.editor;
        const { startContainer, endContainer, startOffset, endOffset } = _range;
        //  console.log(range,  editor.range(range))
        if (startContainer === endContainer) {
            if (startOffset === endOffset)
                return;
            let text = startContainer.text;
            if (startOffset + 1 === endOffset) {
                if (["`", "*", "_", "'", '"'].includes(text[startOffset]) &&
                    text[startOffset] === text[endOffset]) {
                    text = text.slice(0, startOffset) + text.slice(endOffset + 1);
                }
                else if (["{", "[", "("].includes(text[startOffset]) &&
                    text[endOffset] ===
                        { "{": "}", "[": "]", "(": ")" }[text[startOffset]]) {
                    text = text.slice(0, startOffset) + text.slice(endOffset + 1);
                }
                else {
                    text = text.slice(0, startOffset) + text.slice(endOffset);
                }
            }
            else {
                text = text.slice(0, startOffset) + text.slice(endOffset);
            }
            this.applyOperation(createUpdateOperation(editor, startContainer.id, { text }));
        }
        else {
            let text = ((_b = (_a = startContainer === null || startContainer === void 0 ? void 0 : startContainer.text) === null || _a === void 0 ? void 0 : _a.slice) === null || _b === void 0 ? void 0 : _b.call(_a, 0, startOffset)) || '';
            text += ((endContainer === null || endContainer === void 0 ? void 0 : endContainer.text) || '').slice(endOffset);
            this.updateBlock(startContainer, { text });
            const stack = [editor.getCommonBlock(startContainer, endContainer)];
            let flag = false;
            while (stack.length) {
                const block = stack.pop();
                [...((block === null || block === void 0 ? void 0 : block.blocks) || [])].reverse().forEach((b) => {
                    stack.push(b);
                });
                if (flag && (editor.isTextBlock(block.id) || block.type === "hr" || block.type === "table")) {
                    if (((_c = block === null || block === void 0 ? void 0 : block.parent) === null || _c === void 0 ? void 0 : _c.type) === 'table') {
                        this.applyOperation(createUpdateOperation(editor, block.id, { text: "" }));
                    }
                    else {
                        this.applyOperation(createDelOperation(editor, block.id));
                    }
                }
                if (block === startContainer)
                    flag = true;
                if (block === endContainer)
                    break;
            }
        }
        selection.collapse(startContainer, startOffset);
    }
    insertText(data) {
        var _a, _b, _c;
        const { selection } = this.editor;
        const { focusOffset, focusBlock } = selection;
        let text = selection.focusBlock.text || "";
        text = text.slice(0, focusOffset) + data;
        if (["`", "*", "_", "'", '"'].includes(data) &&
            data !== text[focusOffset - 1]) {
            if (selection.focusBlock.text[focusOffset] === data) {
                text = text.slice(0, text.length - 1);
            }
            else {
                text += data;
            }
        }
        if (["{", "[", "("].includes(data)) {
            text += { "{": "}", "[": "]", "(": ")" }[data];
        }
        text += ((_c = (_b = (_a = selection.focusBlock) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.slice) === null || _c === void 0 ? void 0 : _c.call(_b, focusOffset)) || '';
        this.applyOperation(createUpdateOperation(this.editor, selection.focusBlock.id, { text }));
        // console.log(focusOffset, data.length, data, text)
        selection.collapse(focusBlock, focusOffset + data.length);
        Event.emit("block-change", focusBlock);
    }
    updateBlock(block, arg) {
        this.applyOperation(createUpdateOperation(this.editor, block.id, arg));
    }
    updateBlockById(id, arg) {
        this.applyOperation(createUpdateOperation(this.editor, id, arg));
    }
    insertParagraph() {
        const { editor } = this;
        const { selection } = this.editor;
        const { focusBlock, focusOffset } = selection;
        const stext = focusBlock.text.slice(0, focusOffset);
        const etext = focusBlock.text.slice(focusOffset);
        const newBlock = editor.createParagraphBlock(etext);
        this.insertAfter(focusBlock, newBlock);
        this.applyOperation(createUpdateOperation(editor, selection.focusBlock.id, { text: stext }));
        selection.collapse(newBlock);
        return newBlock;
    }
    insertBefore(block, newBlock) {
        const blocks = [...block.parent.blocks];
        const index = blocks.indexOf(block);
        blocks.splice(index, 0, newBlock);
        console.log("insertBefore", blocks);
        this.applyOperation(createUpdateOperation(this.editor, block.parent.id, { blocks }));
    }
    insertAfter(block, newBlock) {
        const blocks = [...block.parent.blocks];
        const index = blocks.indexOf(block);
        blocks.splice(index + 1, 0, newBlock);
        this.applyOperation(createUpdateOperation(this.editor, block.parent.id, { blocks }));
    }
    insertAfterBlocks(block, newBlocks) {
        const blocks = [...block.parent.blocks];
        const index = blocks.indexOf(block);
        blocks.splice(index + 1, 0, ...newBlocks);
        this.applyOperation(createUpdateOperation(this.editor, block.parent.id, { blocks }));
    }
    insertBlocks(blocks) {
        var _a, _b;
        const { selection } = this.editor;
        const { focusBlock, focusOffset } = selection;
        if (!blocks.length)
            return;
        let text = focusBlock.text ? focusBlock.text.slice(0, focusOffset) : "";
        const last = blocks[blocks.length - 1];
        const lastOffset = focusBlock.text.length - focusOffset;
        last.text += ((_b = (_a = focusBlock === null || focusBlock === void 0 ? void 0 : focusBlock.text) === null || _a === void 0 ? void 0 : _a.slice) === null || _b === void 0 ? void 0 : _b.call(_a, focusOffset)) || '';
        const first = blocks.shift();
        text += ((first === null || first === void 0 ? void 0 : first.text) || '');
        this.applyOperation(createUpdateOperation(this.editor, focusBlock.id, { text }));
        if (blocks.length) {
            this.insertAfterBlocks(focusBlock, blocks);
        }
        if (blocks.includes(last)) {
            selection.collapse(last, last.text.length - lastOffset);
        }
        else {
            selection.collapse(focusBlock, focusBlock.text.length - lastOffset);
        }
    }
    replaceBlock(block, newBlock) {
        const blocks = [...block.parent.blocks];
        const index = blocks.indexOf(block);
        blocks.splice(index, 1, newBlock);
        this.applyOperation(createUpdateOperation(this.editor, block.parent.id, { blocks }));
    }
    mergeBlock(targetBlock, block) {
        const blocks = [...targetBlock.blocks, ...block.blocks];
        this.applyOperation(createUpdateOperation(this.editor, targetBlock.id, { blocks }));
    }
    splitList(listBlock, index) {
        const { editor } = this;
        const newBlocks = listBlock.blocks.slice(index + 1);
        this.updateBlock(listBlock, { blocks: listBlock.blocks.slice(0, index + 1) });
        const newList = editor.createListBlock(null, listBlock.ordered, 1, newBlocks);
        this.insertAfter(listBlock, newList);
    }
    splitBlockquote(block, index) {
        const { editor } = this;
        const newBlocks = block.blocks.slice(index + 1);
        this.updateBlock(block, { blocks: block.blocks.slice(0, index + 1) });
        const newList = editor.createBlockquoteBlock(null, newBlocks);
        this.insertAfter(block, newList);
    }
}

const blockMath = {
    name: "block-math",
    level: "block",
    tokenizer(src, tokens) {
        const rule = /^(\${2})\s*([\s\S]*?[^\$])\s*\1(?!\$)/; //
        const match = rule.exec(src);
        if (match) {
            return {
                type: "code",
                lang: "math",
                raw: match[0],
                text: match[2],
            };
        }
    },
    renderer(token) {
        return `\n<inline-math></inline-math>`;
    },
};
const inlineMath = {
    name: "inline-math",
    level: "inline",
    tokenizer(src, tokens) {
        const rule = /\$(.*?)\$/; //
        const match = rule.exec(src);
        if (match) {
            if (match.index === 0) {
                if (!match[1].trim()) {
                    return {
                        type: "text",
                        raw: match[0],
                        text: match[0],
                    };
                }
                return {
                    type: "inline-math",
                    raw: match[0],
                    text: match[1],
                };
            }
            // @ts-ignore
            const list = this.lexer.inlineTokens(src.slice(0, match.index));
            const pre = list[0];
            return pre;
        }
        return false;
    },
    renderer(token) {
        return `\n<inline-math></inline-math>`;
    },
};
marked.marked.use({ extensions: [inlineMath, blockMath] });
// @ts-ignore
window.katex = katex__default["default"];
const turndownService = new TurndownService__default["default"]();
// @ts-ignore
window.marked = marked.marked;
// @ts-ignore
window.turndownService = new TurndownService__default["default"]();
function parseHtml(html) {
    return turndownService.turndown(html);
}
function HtmlToModel(html) {
    return parseMD(parseHtml(html)).blocks;
}
function formatBlock(token) {
    var _a, _b;
    if ([
        "blockquote",
        "heading",
        "list",
        "list_item",
        "paragraph",
        "hr",
        "code",
        "table",
        "space"
    ].includes(token.type)) {
        if ("space" === token.type) {
            return { type: "paragraph", blocks: [], text: "", isBlock: true };
        }
        const block = Object.assign(Object.assign({ blocks: [] }, token), { isBlock: true });
        if (block.type === "list_item") {
            if ((block === null || block === void 0 ? void 0 : block.tokens[0]) && (block === null || block === void 0 ? void 0 : block.tokens[0].type) === "text") {
                block.tokens[0].type = "paragraph";
            }
        }
        if ((_a = block === null || block === void 0 ? void 0 : block.tokens) === null || _a === void 0 ? void 0 : _a.length) {
            block.blocks = block === null || block === void 0 ? void 0 : block.tokens.map(formatBlock).filter((n) => n);
        }
        if (block.type === "list") {
            if (((_b = block === null || block === void 0 ? void 0 : block.items) === null || _b === void 0 ? void 0 : _b.length) === 0)
                return;
            block.blocks = block === null || block === void 0 ? void 0 : block.items.map(formatBlock).filter((n) => n);
        }
        if (block.type === "table") {
            block.header.forEach((b) => {
                b.type = "paragraph";
            });
            block.rows.flat(99).forEach((b) => {
                b.type = "paragraph";
            });
        }
        return block;
    }
}
// @ts-ignore
window.parseMD = parseMD;
function parseMD(md) {
    const tokens = marked.marked.lexer(md); // new marked.Lexer({ breaks: true }).lex(md);
    return {
        type: "root",
        blocks: tokens.map(formatBlock).filter((n) => n),
    };
}
// @ts-ignore
window.modelToMD = modelToMD;
function modelToMD(model) {
    return model.blocks.map((block) => blockToMD(block)).join('\n');
}
function headDepth(depth) {
    return new Array(depth).fill('#').join('');
}
function tableAlign(align) {
    if (align === "center")
        return ":--:";
    if (align === "right")
        return "---:";
    if (align === "left")
        return ":---";
    return '----';
}
function blockToMD(block, listIndex = 0) {
    const { type, text, blocks = [] } = block;
    const childMD = blocks.map(block => blockToMD(block));
    if (type === 'paragraph')
        return text;
    if (type === 'heading')
        return `${headDepth(block.depth)} ${text}`;
    if (type === 'blockquote')
        return childMD.map(md => `> ${md}`).join('\n');
    if (type === 'hr')
        return '---\n';
    if (type === 'list_item') {
        const { task, checked } = block;
        return '- ' + (task ? `[${checked ? 'x' : ' '}] ` : "") + childMD.join('\n').split('\n').join('\n' + '  ');
    }
    if (type === 'list') {
        const { ordered, start = 1 } = block;
        if (ordered) {
            return childMD.map((md, i) => `${start + i}. ${md.slice(2)}`).join('\n');
        }
        return childMD.map(md => `${md}`).join('\n');
    }
    if (type === 'code') {
        return '```' + block.lang + '\n' + text + '\n```';
    }
    if (type === 'table') {
        const { header = [], rows, align } = block;
        let html = `| ${header.map(blockToMD).join(' | ')} |\n`;
        html += `| ${align.map(tableAlign).join(' | ')} |\n`;
        rows.forEach(row => {
            html += `| ${row.map(blockToMD).join(' | ')} |\n`;
        });
        return html;
    }
}

class BaseInputEvent {
    constructor(editor) {
        this.editor = editor;
    }
    accept(inputType, event) {
        return true;
    }
    execute(inputType, event) {
        var _a;
        const { editor } = this;
        const range = editor.range(event.getTargetRanges()[0]);
        if (range.startContainer.type === 'hr') {
            const p = editor.createParagraphBlock();
            editor.model.replaceBlock(range.startContainer, p);
            editor.model.normalize(range.startContainer.parent);
            range.startContainer = p;
        }
        if (inputType.startsWith('delete')) {
            if (editor.selection.focusOffset === 0 && editor.selection.type === 'Caret') {
                let pre = editor.getPreviousTextBlock(editor.selection.focusBlock.id);
                if (pre.type === 'hr') {
                    const p = editor.createParagraphBlock();
                    editor.model.replaceBlock(pre, p);
                    editor.model.normalize(pre.parent);
                    pre = p;
                }
                range.startContainer = pre;
                range.startOffset = ((_a = pre.text) === null || _a === void 0 ? void 0 : _a.length) || 0;
            }
            editor.model.deleteContent(range);
        }
        if (inputType === 'insertText') {
            editor.model.deleteContent(range);
            editor.model.insertText(event.data);
        }
        if (inputType === 'insertParagraph') {
            editor.model.deleteContent(range);
            editor.model.insertParagraph();
        }
        if (inputType === 'insertFromPaste') {
            const { clipboard } = editor;
            editor.model.deleteContent(range);
            clipboard.getData().then(blocks => blocks && editor.model.insertBlocks(blocks));
        }
        if (inputType === 'insertFromDrop') {
            const { clipboard } = editor;
            clipboard.addData(event.dataTransfer);
            const { startContainer, startOffset } = editor.range(range);
            editor.selection.collapse(startContainer, startOffset);
            clipboard.getData().then(blocks => blocks && editor.model.insertBlocks(blocks));
        }
        return true;
    }
}

class BlockquoteInputEvent {
    constructor(editor) {
        this.editor = editor;
    }
    accept(inputType, event) {
        const { editor } = this;
        const { selection } = editor;
        const { focusOffset, focusBlock } = selection;
        if (focusOffset === 0 &&
            inputType.startsWith("delete") &&
            focusBlock.parent.type === "blockquote" &&
            focusBlock.parent.blocks.indexOf(focusBlock) === 0 &&
            selection.type === "Caret") {
            return true;
        }
        if (focusBlock.text === "" &&
            inputType === "insertParagraph" &&
            focusBlock.parent.type === "blockquote" &&
            selection.type === "Caret") {
            //focusBlock.parent.blocks.indexOf(focusBlock) + 1 === focusBlock.parent.blocks.length
            return true;
        }
        return false;
    }
    execute(inputType, event) {
        const { editor } = this;
        const { selection } = editor;
        const { focusOffset, focusBlock } = selection;
        if (focusOffset === 0 &&
            inputType.startsWith("delete") &&
            focusBlock.parent.type === "blockquote" &&
            focusBlock.parent.blocks.indexOf(focusBlock) === 0) {
            editor.model.deleteBlock(focusBlock.id);
            editor.model.insertBefore(focusBlock.parent, focusBlock);
            return true;
        }
        if (focusBlock.text === "" &&
            inputType === "insertParagraph" &&
            focusBlock.parent.type === "blockquote" &&
            selection.type === "Caret") {
            // 首行退出
            if (focusBlock.parent.blocks.indexOf(focusBlock) === 0) {
                editor.model.deleteBlock(focusBlock.id);
                editor.model.insertBefore(focusBlock.parent, focusBlock);
                return true;
            }
            // 尾部退出
            if (focusBlock.parent.blocks.indexOf(focusBlock) + 1 === focusBlock.parent.blocks.length) {
                editor.model.deleteBlock(focusBlock.id);
                editor.model.insertAfter(focusBlock.parent, focusBlock);
                return true;
            }
            // 分割
            editor.model.splitBlockquote(focusBlock.parent, focusBlock.parent.blocks.indexOf(focusBlock));
            editor.model.deleteBlock(focusBlock.id);
            editor.model.insertAfter(focusBlock.parent, focusBlock);
            return true;
        }
        return true;
    }
}

class ListInputEvent {
    constructor(editor) {
        this.editor = editor;
    }
    accept(inputType, event) {
        const { editor } = this;
        const { selection } = editor;
        const { focusOffset, focusBlock } = selection;
        if (focusOffset === 0 &&
            inputType.startsWith("delete") &&
            focusBlock.parent.type === "list_item" &&
            focusBlock.parent.blocks.indexOf(focusBlock) === 0 &&
            selection.type === "Caret" &&
            focusBlock.parent.parent.blocks.indexOf(focusBlock.parent) !== 0) {
            return true;
        }
        if (inputType === "insertParagraph" &&
            selection.type === "Caret" &&
            focusBlock.parent.type === "list_item" &&
            ((focusBlock.parent.blocks.indexOf(focusBlock) + 1 ===
                focusBlock.parent.blocks.length &&
                focusBlock.text === "") ||
                focusBlock.parent.blocks.indexOf(focusBlock) === 0)) {
            return true;
        }
        return false;
    }
    execute(inputType, event) {
        const { editor } = this;
        const { selection } = editor;
        const { focusOffset, focusBlock } = selection;
        if (focusOffset === 0 &&
            inputType.startsWith("delete") &&
            focusBlock.parent.type === "list_item" &&
            focusBlock.parent.blocks.indexOf(focusBlock) === 0 &&
            selection.type === "Caret") {
            const preBlock = editor.getPreviousBlock(focusBlock.parent);
            if (preBlock.blocks.length === 1 && preBlock.blocks[0].text === "") {
                editor.model.deleteBlock(preBlock.blocks[0].id);
            }
            editor.model.mergeBlock(preBlock, focusBlock.parent);
            editor.model.deleteBlock(focusBlock.parent.id);
        }
        if (inputType === "insertParagraph") {
            if (focusBlock.parent.blocks.indexOf(focusBlock) === 0) {
                if (focusBlock.text === "" && focusBlock.parent.blocks.length === 1) {
                    // list 最后一个退出
                    if (focusBlock.parent.parent.blocks.indexOf(focusBlock.parent) ===
                        focusBlock.parent.parent.blocks.length - 1) {
                        editor.model.deleteBlock(focusBlock.parent.id);
                        editor.model.insertAfter(focusBlock.parent.parent, focusBlock);
                        return true;
                    }
                    // 切割 list
                    if (focusBlock.parent.parent.blocks.indexOf(focusBlock.parent) !== 0) {
                        editor.model.splitList(focusBlock.parent.parent, focusBlock.parent.parent.blocks.indexOf(focusBlock.parent));
                        editor.model.deleteBlock(focusBlock.parent.id);
                        editor.model.insertAfter(focusBlock.parent.parent, focusBlock);
                        return true;
                    }
                }
                const newBlock = editor.createListItemBlock(editor.createParagraphBlock(focusBlock.text.slice(0, focusOffset)), focusBlock.parent.task, focusBlock.parent.checked);
                const text = focusBlock.text.slice(focusOffset);
                editor.model.updateBlock(focusBlock, { text });
                editor.model.insertBefore(focusBlock.parent, newBlock);
                selection.collapse(focusBlock);
            }
            // item 内部跳出
            if (focusBlock.text === "" &&
                focusBlock.parent.blocks.indexOf(focusBlock) + 1 ===
                    focusBlock.parent.blocks.length) {
                editor.model.insertAfter(focusBlock.parent, editor.createListItemBlock(focusBlock, focusBlock.parent.task, focusBlock.parent.checked));
                editor.model.deleteBlock(focusBlock.id);
            }
        }
        return true;
    }
}

class CodeInputEvent {
    constructor(editor) {
        this.editor = editor;
    }
    accept(inputType, event) {
        const { editor } = this;
        if (inputType === "insertParagraph" && editor.selection.focusBlock.type === "code") {
            return true;
        }
        if (inputType.startsWith("delete") && editor.selection.type === "Caret" && editor.selection.focusBlock.type === "code" && editor.selection.focusOffset === 0) {
            return true;
        }
        return false;
    }
    execute(inputType, event) {
        const { editor } = this;
        if (inputType === "insertParagraph") {
            editor.model.deleteContent(event.getTargetRanges()[0]);
            editor.model.insertText('\n');
        }
        if (inputType.startsWith("delete")) {
            if (!editor.selection.focusBlock.text || editor.selection.focusBlock.text === '\n') {
                editor.model.deleteContent(event.getTargetRanges()[0]);
            }
        }
        return true;
    }
}

class TableInputEvent {
    constructor(editor) {
        this.editor = editor;
    }
    accept(inputType, event) {
        const { editor } = this;
        const { selection } = editor;
        const { focusOffset, focusBlock, anchorBlock } = selection;
        if (focusOffset === 0 &&
            inputType.startsWith("delete") &&
            focusBlock.parent.type === "table" &&
            focusBlock.parent.blocks.indexOf(focusBlock) === 0 &&
            selection.type === "Caret") {
            return true;
        }
        if (inputType === "insertParagraph" &&
            (focusBlock.parent.type === "table" || anchorBlock.parent.type === "table")) {
            return true;
        }
        return false;
    }
    execute(inputType, event) {
        const { editor } = this;
        const { selection } = editor;
        const { focusOffset, focusBlock } = selection;
        if (focusOffset === 0 &&
            inputType.startsWith("delete") &&
            focusBlock.parent.type === "table" &&
            focusBlock.parent.blocks.indexOf(focusBlock) === 0 &&
            selection.type === "Caret") {
            const block = editor.getPreviousTextBlock(focusBlock.id);
            editor.model.deleteBlock(focusBlock.parent.id);
            selection.collapse(block, block.text.length);
        }
        return true;
    }
}

class HeadingInputEvent {
    constructor(editor) {
        this.editor = editor;
    }
    accept(inputType, event) {
        const { editor } = this;
        if (inputType.startsWith("delete") && editor.selection.type === "Caret" && editor.selection.focusBlock.type === "heading" && editor.selection.focusOffset === 0) {
            return true;
        }
        return false;
    }
    execute(inputType, event) {
        const { editor } = this;
        if (inputType.startsWith("delete")) {
            const newBlock = editor.createParagraphBlock(editor.selection.focusBlock.text);
            editor.model.replaceBlock(editor.selection.focusBlock, newBlock);
            editor.selection.collapse(newBlock);
        }
        return true;
    }
}

class HrInputEvent {
    constructor(editor) {
        this.editor = editor;
    }
    accept(inputType, event) {
        const { editor } = this;
        if (editor.selection.focusBlock.type === "hr") {
            return true;
        }
        return false;
    }
    execute(inputType, event) {
        if (inputType.startsWith("delete")) ;
        if (inputType.startsWith("insert")) ;
        return false;
    }
}

// import hotkeys from "hotkeys-js"
class History {
    constructor(editor) {
        this.undoStack = [];
        this.redoStack = [];
        this.pauseRecord = false;
        this.optimer = null;
        this.operations = [];
        this.beforeSelection = null;
        this.editor = editor;
        this.init();
    }
    init() {
        Event.on("apply-operation", this.applyOperationStart.bind(this));
    }
    applyOperationStart(operation) {
        if (this.pauseRecord)
            return;
        if (!this.beforeSelection) {
            const { focusBlock, focusOffset, type, range } = this.editor.selection;
            this.beforeSelection = { focusBlock, focusOffset, type, range };
        }
        this.operations.push(operation);
        if (this.optimer)
            clearTimeout(this.optimer);
        const { operations } = this;
        if (operation.type === "update" && (operations.length === 1 || (operations[operations.length - 2].type === 'update' && operations[operations.length - 2].arg.id === operation.arg.id))) {
            this.optimer = setTimeout(() => this.applyOperationEnd(), 200);
        }
        else {
            this.optimer = setTimeout(() => this.applyOperationEnd(), 0);
        }
    }
    applyOperationEnd() {
        const { focusBlock, focusOffset, type, range } = this.editor.selection;
        const { operations, beforeSelection } = this;
        console.log(operations);
        this.add({ ops: operations, before: beforeSelection, after: { focusBlock, focusOffset, type, range } });
        this.operations = [];
        this.beforeSelection = null;
        this.optimer = null;
    }
    add(record) {
        this.undoStack.push(record);
    }
    undo() {
        const { editor } = this;
        if (this.undoStack.length === 0)
            return;
        const record = this.undoStack.pop();
        this.pauseRecord = true;
        record.ops.reverse().forEach((op) => {
            editor.model.applyOperation(op.invert());
        });
        this.pauseRecord = false;
        const { before } = record;
        if (before.type === "Range") {
            editor.selection.selection.addRange(before.range.cloneRange());
        }
        else {
            editor.selection.collapse(before.focusBlock, before.focusOffset);
        }
    }
    redo() { }
}

class clipboard {
    constructor(editor) {
        this.editor = editor;
    }
    addData(dataTransfer) {
        const { editor } = this;
        // console.log(dataTransfer.getData('Files'), dataTransfer.types)
        if (dataTransfer.types.includes("Files")) {
            this.contnet = Promise.all(Array.from(dataTransfer.files).map((file) => __awaiter(this, void 0, void 0, function* () {
                if (file.type.startsWith('image')) {
                    return editor.createParagraphBlock(`![${file.name}](${URL.createObjectURL(yield fileToBlob(file))})`);
                }
                return editor.createParagraphBlock(file.name);
            })));
        }
        if (dataTransfer.types.includes("text/html")) {
            this.contnet = Promise.resolve(HtmlToModel(dataTransfer.getData("text/html")));
            return;
        }
        else if (dataTransfer.types.includes("text/plain")) {
            const text = dataTransfer.getData("text/plain");
            // console.log('onPaste', text)
            this.contnet = Promise.resolve(parseMD(text).blocks);
        }
    }
    getData() {
        return __awaiter(this, void 0, void 0, function* () {
            const { contnet } = this;
            this.contnet = null;
            return yield contnet;
        });
    }
}

function ConvertBlock(editor, block) {
    const { model, selection } = editor;
    if (block.type === "heading" || block.type === "paragraph") {
        // heading
        if (/^(#+)\s(.*)/.test(block.text)) {
            const newBlock = editor.createHeading(block.text);
            selection.focusOffset -= newBlock.depth;
            model.replaceBlock(block, newBlock);
            selection.collapse(newBlock);
        }
        if (/^[+]{0,1}(\d+)\.\s/.test(block.text)) {
            const start = block.text.split(".")[0];
            const newBlock = editor.createListBlock(block, true, Number(start));
            // block.text = block.text.replace("- ", "");
            selection.focusOffset -= start.length + 1;
            model.updateBlock(block, {
                text: block.text.replace(/^[+]{0,1}(\d+)\.\s/, ""),
            });
            model.replaceBlock(block, newBlock);
            selection.collapse(newBlock);
        }
        // ul
        if (/^[\\s]*[-\\*\\+] +(.*)/.test(block.text)) {
            const newBlock = editor.createListBlock(block);
            // block.text = block.text.replace("- ", "");
            selection.focusOffset -= 2;
            model.updateBlock(block, { text: block.text.replace("- ", "") });
            model.replaceBlock(block, newBlock);
            selection.collapse(newBlock);
        }
        // quote
        if (block.text.startsWith("> ")) {
            const newBlock = editor.createBlockquoteBlock(block);
            selection.focusOffset -= 2;
            model.updateBlock(block, { text: block.text.replace("> ", "") });
            model.replaceBlock(block, newBlock);
            selection.collapse(newBlock);
        }
        // hr
        if (block.text.startsWith("---")) {
            selection.collapse(editor.getNextTextBlock(block.id));
            model.replaceBlock(block, editor.createHrBlock());
        }
        // task
        if (/^\[[\s,x]\]/.test(block.text)) {
            if (block.parent.type === "list_item" &&
                block.parent.blocks.indexOf(block) === 0) {
                selection.focusOffset -= 2;
                model.updateBlock(block.parent, {
                    task: true,
                    checked: block.text.startsWith("[x]"),
                });
                model.updateBlock(block, {
                    text: block.text.replace(/^\[[\s,x]\]/, ""),
                });
            }
        }
    }
}
class Editor {
    constructor({ md = '' }) {
        this.inputStrategys = [];
        this.idToBlock = new Map();
        this.idToDom = new Map();
        this.DomToBlock = new WeakMap();
        this.onPaste = (event) => {
            const { clipboardData } = event;
            this.clipboard.addData(clipboardData);
        };
        this.onBeforeInput = (event) => {
            const { inputType } = event;
            console.log({ inputType });
            // if(this.selection.focusBlock.type === "code") return
            if (this.isComposing ||
                inputType === "insertCompositionText" ||
                inputType === "deleteCompositionText") {
                return;
            }
            if (inputType === "insertParagraph" && this.insertParagraphBefore(event)) {
                // insertParagraph 之前
                return;
            }
            // console.log('onPaste', event.dataTransfer )
            this.applyInputStrategys(inputType, event);
            // event.stopPropagation()
            event.preventDefault();
            return;
        };
        this.isComposing = false;
        this.onCompositionstart = () => {
            this.isComposing = true;
            this.compositionOffset = this.selection.focusOffset;
        };
        this.onCompositionupdate = () => { };
        this.onCompositionend = (event) => {
            this.isComposing = false;
            // console.log("onDomCompositionend", event.data);
            this.selection.focusOffset = this.compositionOffset;
            this.model.insertText(event.data);
        };
        this.onKeyDown = (event) => {
            if (event.key === 'Tab') {
                this.tabKeyDown(event);
                event.preventDefault();
            }
            // console.log(event.key, event)
            event.stopPropagation();
            if (event.metaKey && event.key === "z") {
                this.history.undo();
            }
            if (['[', ']'].includes(event.key) && event.metaKey) {
                event.preventDefault();
                if (event.key === '[')
                    this.listShrink();
                else
                    this.listExpand();
            }
            if (this.onKeyDownInTable(event))
                return;
            if (this.onKeyDownInCode(event))
                return;
        };
        this.onKeyDownInCode = (event) => {
            const { selection } = this;
            const { focusBlock, focusOffset } = selection;
            if ((focusBlock === null || focusBlock === void 0 ? void 0 : focusBlock.type) === 'code') {
                if (event.key === 'Enter' && event.metaKey && focusOffset + 1 >= focusBlock.text.length) {
                    selection.collapse(this.getNextBlock(focusBlock));
                    selection.reset();
                    return true;
                }
            }
        };
        this.onKeyDownInTable = (event) => {
            var _a;
            const { selection } = this;
            const { focusBlock } = selection;
            if (((_a = focusBlock === null || focusBlock === void 0 ? void 0 : focusBlock.parent) === null || _a === void 0 ? void 0 : _a.type) === 'table') {
                const rowLen = focusBlock.parent.header.length;
                const i = focusBlock.parent.blocks.indexOf(focusBlock);
                if (event.key === "Backspace" && event.metaKey && event.shiftKey) {
                    event.preventDefault();
                    this.deleteTableRow(focusBlock === null || focusBlock === void 0 ? void 0 : focusBlock.parent, Math.ceil((i + 1) / rowLen));
                    selection.collapse(focusBlock.parent.blocks[i] || focusBlock.parent.blocks[i - rowLen]);
                }
                if (event.key === 'Enter') {
                    if (event.metaKey) {
                        this.insertAfterTableRow(focusBlock === null || focusBlock === void 0 ? void 0 : focusBlock.parent, Math.ceil((i + 1) / rowLen));
                        selection.collapse(focusBlock.parent.blocks[Math.ceil((i + 1) / rowLen) * rowLen]);
                    }
                    else {
                        selection.collapse(focusBlock.parent.blocks[i + rowLen] || this.getNextBlock(focusBlock.parent));
                        selection.reset();
                    }
                }
                return true;
            }
        };
        this.tabKeyDown = ({ shiftKey }) => {
            this.selection;
            if (shiftKey) {
                this.listShrink();
            }
            else {
                if (this.listExpand())
                    return;
                this.model.insertText('\t');
            }
        };
        this.history = new History(this);
        this.model = new Model(this, parseMD(md));
        this.selection = new Selection(this);
        this.clipboard = new clipboard(this);
        this.inputStrategys.push(new BaseInputEvent(this));
        this.inputStrategys.push(new BlockquoteInputEvent(this));
        this.inputStrategys.push(new ListInputEvent(this));
        this.inputStrategys.push(new CodeInputEvent(this));
        this.inputStrategys.push(new TableInputEvent(this));
        this.inputStrategys.push(new HeadingInputEvent(this));
        this.inputStrategys.push(new HrInputEvent(this));
        Event.on("block-change", this.blockChange.bind(this));
    }
    get textPath() {
        const list = [];
        const stack = [this.model._model];
        while (stack.length) {
            let block = stack.pop();
            if (['paragraph', 'heading', 'code', 'hr'].includes(block.type)) {
                list.push(block.id);
            }
            stack.push(...([...block.blocks || []]).reverse());
        }
        return list;
    }
    blockChange(block) {
        var _a;
        if (((_a = block === null || block === void 0 ? void 0 : block.parent) === null || _a === void 0 ? void 0 : _a.type) !== 'table')
            ConvertBlock(this, block);
    }
    applyInputStrategys(inputType, Event) {
        const strategys = [...this.inputStrategys];
        while (strategys.length) {
            const strategy = strategys.pop();
            if (strategy.accept(inputType, Event)) {
                if (strategy.execute(inputType, Event))
                    return;
            }
        }
    }
    // onEnter
    insertParagraphBefore(event) {
        const { selection, model } = this;
        const { focusBlock } = selection;
        if (focusBlock.type === 'hr')
            return;
        if (focusBlock.text.trimEnd() === "$$" &&
            focusBlock.type === "paragraph") {
            const newBlock = this.createCodeBlock("math", "");
            model.replaceBlock(focusBlock, newBlock);
            selection.collapse(newBlock);
            event.preventDefault();
            return true;
        }
        if (/^\`{3,10}[A-Za-z0-9]*$/.test(focusBlock.text) &&
            focusBlock.type === "paragraph") {
            const newBlock = this.createCodeBlock(focusBlock.text.replace(/^\`{3,10}[A-Za-z0-9]*$/, ""));
            model.replaceBlock(focusBlock, newBlock);
            selection.collapse(newBlock);
            event.preventDefault();
            return true;
        }
        // table
        const tableMatch = /^\|.*?(\\*)\|.*?(\\*)\|$/.exec(focusBlock.text);
        if (tableMatch) {
            this.getPreviousTextBlock(focusBlock.id);
            const tableBlock = this.createTable(tableMatch[0].split('|').length - 2);
            model.replaceBlock(focusBlock, tableBlock);
            selection.collapse(tableBlock.header[0]);
            event.preventDefault();
            return true;
        }
    }
    // list 向上收缩
    listShrink() {
        const { focusBlock } = this.selection;
        if (focusBlock.parent.type === 'list_item' && focusBlock.parent.parent.parent.type === 'list_item') {
            // this.model.deleteBlock(focusBlock.parent.id)
            if (focusBlock.parent.blocks.indexOf(focusBlock) === 0) {
                const itemIndex = focusBlock.parent.parent.blocks.indexOf(focusBlock.parent);
                if (itemIndex === 0 && focusBlock.parent.parent.parent.blocks.indexOf(focusBlock.parent.parent) === 0) {
                    this.model.deleteBlock(focusBlock.parent.id);
                    this.model.insertBefore(focusBlock.parent.parent.parent, focusBlock.parent);
                    return;
                }
                const nextList = this.createListBlock(null, focusBlock.parent.parent.ordered, 1, focusBlock.parent.parent.blocks.slice(itemIndex + 1));
                this.model.updateBlock(focusBlock.parent.parent, { blocks: focusBlock.parent.parent.blocks.slice(0, itemIndex) });
                this.model.insertAfter(focusBlock.parent.parent.parent, focusBlock.parent);
                this.model.insertAfter(focusBlock, nextList);
            }
            else {
                // listitem 非首行退出
                // const index = focusBlock.parent.blocks.indexOf(focusBlock)
                // const blocks = focusBlock.parent.blocks.slice(index)
                // this.model.updateBlock(focusBlock.parent, {blocks: focusBlock.parent.blocks.slice(0, index)})
                return;
            }
        }
    }
    // list 向下扩展
    listExpand() {
        const { focusBlock } = this.selection;
        const preTextBlock = this.getPreviousTextBlock(focusBlock.id);
        if (focusBlock.parent.type === 'list_item' && preTextBlock.parent.type === 'list_item') {
            if (focusBlock.parent.parent.blocks.indexOf(focusBlock.parent) !== 0 && focusBlock.parent.blocks.indexOf(focusBlock) === 0) {
                this.model.deleteBlock(focusBlock.parent.id);
                this.model.insertAfter(preTextBlock, this.createListBlock(null, focusBlock.parent.parent.ordered, 1, [focusBlock.parent]));
                return true;
            }
        }
    }
    domToBlock(domNode) {
        const { DomToBlock } = this;
        while (domNode && !DomToBlock.get(domNode)) {
            domNode = domNode.parentNode;
        }
        return DomToBlock.get(domNode);
    }
    fixOffset(node, offset = 0) {
        const { DomToBlock } = this;
        let parent = node;
        while (parent && !DomToBlock.get(parent))
            parent = parent.parentNode;
        if (parent === node)
            return { node, offset, block: DomToBlock.get(node) };
        for (let tnode of iterationTextNode(parent)) {
            if (tnode === node)
                break;
            offset += tnode.length;
        }
        return { node: parent, offset, block: DomToBlock.get(parent) };
    }
    range(range) {
        const { endContainer, startContainer, endOffset, startOffset } = range;
        const start = this.fixOffset(startContainer, startOffset);
        const end = this.fixOffset(endContainer, endOffset);
        return {
            endOffset: end.offset,
            startOffset: start.offset,
            startContainer: start.block,
            endContainer: end.block,
        };
    }
    contains(parentBlocks, block) {
        if (!parentBlocks.blocks)
            return false;
        for (let b of parentBlocks.blocks) {
            if (b === block || this.contains(b, block))
                return true;
        }
        return false;
    }
    getCommonBlock(block1, block2) {
        if (!block1 || !block2)
            return null;
        if (this.contains(block1, block2)) {
            return block1;
        }
        else {
            return this.getCommonBlock(block1.parent, block2); // 递归的使用
        }
    }
    getDomByid(id) {
        return this.idToDom.get(id);
    }
    getBlockByid(id) {
        return this.idToBlock.get(id);
    }
    getTextByid(id) {
        let node = this.idToDom.get(id);
        while (node && !["#text", "BR"].includes(node.nodeName)) {
            node = node.firstChild;
        }
        return node;
    }
    createParagraphBlock(text = "") {
        return {
            blocks: [],
            isBlock: true,
            text,
            type: "paragraph",
        };
    }
    createHrBlock(text = "") {
        return {
            blocks: [],
            isBlock: true,
            type: "hr",
        };
    }
    createCodeBlock(lang = "", text = "") {
        return { lang, raw: "", text, type: "code" };
    }
    createBlockquoteBlock(block, blocks = [block]) {
        return {
            blocks,
            isBlock: true,
            type: "blockquote",
        };
    }
    createListItemBlock(block, task = false, checked = false, blocks = [block]) {
        return {
            blocks,
            isBlock: true,
            task,
            checked,
            type: "list_item",
        };
    }
    createListBlock(block, ordered = false, start = 1, blocks = [this.createListItemBlock(block)]) {
        return {
            blocks,
            isBlock: true,
            type: "list",
            ordered: ordered,
            start,
        };
    }
    createHeading(text = "# ") {
        return Object.assign(Object.assign({}, marked.marked.lexer(text)[0]), { blocks: [] });
    }
    createTable(len = 2) {
        return {
            type: "table",
            align: new Array(len).fill(null),
            header: new Array(len).fill(null).map(() => this.createParagraphBlock()),
            rows: [new Array(len).fill(null).map(() => this.createParagraphBlock())]
        };
    }
    getPreviousBlock(block) {
        const index = block.parent.blocks.indexOf(block);
        return index === 0 ? block.parent : block.parent.blocks[index - 1];
    }
    getNextBlock(block) {
        if (!block)
            return null;
        const index = block.parent.blocks.indexOf(block);
        return index === block.parent.blocks.length - 1
            ? this.getNextBlock(block.parent) || block
            : block.parent.blocks[index + 1];
    }
    getPreviousTextBlock(id) {
        const { textPath } = this;
        let index = textPath.indexOf(id);
        return this.getBlockByid(index === 0 ? id : textPath[index - 1]);
    }
    getNextTextBlock(id) {
        const { textPath } = this;
        let index = textPath.indexOf(id);
        return this.getBlockByid(index === textPath.length - 1 ? id : textPath[index + 1]);
    }
    isTextBlock(id) {
        const { textPath } = this;
        return textPath.includes(id);
    }
    addLastLine() {
        const { textPath } = this;
        let lastBlock = this.getBlockByid(textPath[textPath.length - 1]);
        while (lastBlock && lastBlock.parent.type !== 'root') {
            lastBlock = lastBlock.parent;
        }
        this.model.insertAfter(lastBlock, this.createParagraphBlock());
    }
    setMarkDown(md = '') {
        this.model.setModel(parseMD(md));
    }
    toMDString() {
        return modelToMD(this.model._model);
    }
    insertAfterTableRow(tableBlock, index) {
        let rows;
        const row = new Array(tableBlock.header.length).fill(1).map(() => this.createParagraphBlock());
        if (index === 0) {
            rows = [row, ...tableBlock.rows];
        }
        else {
            rows = [...tableBlock.rows];
            rows.splice(index - 1, 0, row);
        }
        this.model.updateBlock(tableBlock, { rows });
        this.model.normalize(tableBlock);
    }
    deleteTableRow(tableBlock, index) {
        let header = tableBlock.header, rows;
        if (index === 1) {
            header = tableBlock.rows[0] || header;
            rows = [...tableBlock.rows];
            rows.splice(0, 1);
        }
        else {
            rows = [...tableBlock.rows];
            rows.splice(index - 2, 1);
        }
        this.model.updateBlock(tableBlock, { header, rows });
        this.model.normalize(tableBlock);
    }
}
// export const editor = new Editor();
// @ts-ignore
// window.editor = editor;
// export let index = 0;
// export const idToBlock = {};
// export const editor = createEditor({ model: formatRoot(tokens) });
// window.editor = editor;

var test = "\n# Markdown 测试语法\n\n---\nღ•⁂€™↑→↓⇝√∞░▲▶◀●☀☁☂☃☄★☆☉☐☑☎☚☛☜☝☞☟☠☢☣☪☮☯☸☹☺☻☼☽☾♔♕♖♗♘♚♛♜♝♞♟♡♨♩♪♫♬✈✉✍✎✓✔✘✚✞✟✠✡✦✧✩✪✮✯✹✿❀❁❂❄❅❆❝❞❣❤❥❦➤\n\n---\n\n### 1. 斜体和粗体\n\n> 使用 * 和 ** 表示斜体和粗体\n> 使用 _ 和 __ 表示斜体和粗体\n> 使用 ~~ 删除线\n> 使用 ~~ 删除线\n\n这是 *斜体*，这是 **粗体**。\n\n~~删除线~~\n*斜体字*      _斜体字_\n**粗体**  __粗体__\n***粗斜体*** ___粗斜体___\n\n\n\n### 2. 分级标题\n\n> 你可以选择在行首加井号表示不同级别的标题 (H1-H6)，例如：# H1, ## H2, ### H3，#### H4。\n\n# Heading 1 link [Heading link](http://github.com/nobey \"Heading link\")\n## Heading 2 link [Heading link](http://github.com/nobey \"Heading link\")\n### Heading 3 link [Heading link](http://github.com/nobey \"Heading link\")\n#### Heading 4 link [Heading link](http://github.com/nobey \"Heading link\") Heading link [Heading link](http://github.com/nobey \"Heading link\")\n##### Heading 5 link [Heading link](http://github.com/nobey \"Heading link\")\n###### Heading 6 link [Heading link](http://github.com/nobey \"Heading link\")\n\n\n\n\n### 3. 外链接\n```md\n使用 [描述](链接地址) 为文字增加外链接。\n```\n使用 [描述](链接地址) 为文字增加外链接。\n\n示例：\n\n这是去往 [本人](http://github.com/nobey) 的链接。\n\n### 4. 无序列表\n\n```md\n- 无序列表项\n- 无序列表项\n\n+ 无序列表项\n+ 无序列表项\n\n- 无序列表项\n- 无序列表项\n```\n\n使用 *，+，- 表示无序列表。\n\n示例：\n\n- 无序列表项 一\n- 无序列表项 二\n- 无序列表项 三\n  - sdd\n    dsd\n  - dsdds\n  - dsdds\n\n### 5. 有序列表\n\n\n```md\n1. 无序列表项\n2. 无序列表项\n```\n\n使用数字和点表示有序列表。\n\n示例：\n\n1. 有序列表项 一\n2. 有序列表项 二\n3. 有序列表项 三\n\n        \n- [ ] **Cmd Markdown 开发**\n    - [ ] 改进 Cmd 渲染算法，使用局部渲染技术提高渲染效率\n    - [ ] 支持以 PDF 格式导出文稿\n    - [x] 新增Todo列表功能 [语法参考](https://github.com/blog/1375-task-lists-in-gfm-issues-pulls-comments)\n    - [x] 改进 LaTex 功能\n        - [x] 修复 LaTex 公式渲染问题\n        - [x] 新增 LaTex 公式编号功能 [语法参考](http://docs.mathjax.org/en/latest/tex.html#tex-eq-numbers)\n- [ ] **七月旅行准备**\n    - [ ] 准备邮轮上需要携带的物品\n    - [ ] 浏览日本免税店的物品\n    - [x] 购买蓝宝石公主号七月一日的船票\n\n\n### 6. 文字引用\n\n```md\n> 表示文字引用\n```\n使用 > 表示文字引用。\n\n示例：\n\n> 野火烧不尽，春风吹又生。\n\n### 7. 行内代码块\n\n使用 \\`代码` 表示行内代码块。\n\n示例：\n\n让我们聊聊 `html`。\n\n### 8. 代码块\n\n\n```md\n ```js\n  // 这是一个代码块，\n  var html = 'js'\n ```                                        .\n```\n使用 三个 ` 表示代码块 后面加上高亮语言。\n\nPython 示例：\n\n```python\n@requires_authorization\ndef somefunc(param1='', param2=0):\n    '''A docstring'''\n    if param1 > param2: # interesting\n        print 'Greater'\n    return (param2 - param1 + 1) or None\n\nclass SomeClass:\n    pass\n\n>>> message = '''interpreter\n... prompt'''\n```\n\nJavaScript 示例：\n\n``` javascript\n/**\n* nth element in the fibonacci series.\n* @param n >= 0\n* @return the nth element, >= 0.\n*/\nfunction fib(n) {\n  var a = 1, b = 1;\n  var tmp;\n  while (--n >= 0) {\n    tmp = a;\n    a += b;\n    b = tmp;\n  }\n  return a;\n}\n\ndocument.write(fib(10));\n```\n\n### 9.  插入图像\n\n使用 \\!\\[描述](图片链接地址) 插入图像。\n\n示例：\n\n![我的头像](https://avatars.githubusercontent.com/u/10740524?v=4) \n\n\n### 10. LaTeX 公式\n\n$ 表示行内公式： \n\n质能守恒方程可以用一个很简洁的方程式 $E=mc^2$ 来表达。\n\n表示整行公式：\n\n$$\\sum_{i=1}^n a_i=0$$\n\n$$f(x_1,x_x,\\ldots,x_n) = x_1^2 + x_2^2 + \\cdots + x_n^2 $$\n\n$$\\sum^{j-1}_{k=0}{\\widehat{\\gamma}_{kj} z_k}$$\n\n访问 [MathJax](http://meta.math.stackexchange.com/questions/5020/mathjax-basic-tutorial-and-quick-reference) 参考更多使用方法。\n\n\n\n\n\n### 11. 流程图\n\n#### 示例\n\n```flow\nst=>start: Start:>https://www.zybuluo.com\nio=>inputoutput: verification\nop=>operation: Your Operation\ncond=>condition: Yes or No?\nsub=>subroutine: Your Subroutine\ne=>end\n\nst->io->op->cond\ncond(yes)->e\ncond(no)->sub->io\n```\n\n#### 更多语法参考：[流程图语法参考](http://adrai.github.io/flowchart.js/)\n\n### 12. 表格支持\n\n| 项目        | 价格   |  数量  |\n| --------   | -----:  | :----:  |\n| 计算机     | \\$1600 |   5     |\n| 手机        |   \\$12   |   12   |\n| 管线        |    \\$1    |  234  |\n\n";

function App() {
    const editor = new Editor({ md: `${test}` });
    // @ts-ignore 
    window.editor = editor;
    return React__default["default"].createElement(Edit, { editor: editor },
        React__default["default"].createElement(Root, null));
}
// const root = document.createElement('div');
// document.body.appendChild(root)
// ReactDOM.render(<App />, root);

exports.App = App;
exports.Edit = Edit;
exports.Editor = Editor;
exports.Root = Root;
